<!-- 客户营销--发送 -->
<template>
  <div class="page_condition">
    <!--条件刷选-->
    <el-drawer
      :withHeader="false"
      :show-close="false"
      :visible.sync="drawers"
      :direction="'rtl'"
      :before-close="handleClose"
      :size="'1000px'"
      custom-class="outside_Drawer"
    >
      <!-- :size="drawerWidth" -->
      <div class="mask">
        <div class="box-hugs" key="1546">
          <div class="box-content-hug">
            <div class="box-content" v-loading="selectLoading">
              <div>
                <span class="page_title">创建任务</span>
                <span @click="ModularBtnClose()" class="del_icon">x</span>
              </div>
              <!-- <div class="top_step">
                <div class="top_step_item" :class="{'step1': stepNum == 1,'step3': stepNum != 1}" @click="stepNum = 1">
                  <span class="circle_icon" v-if="stepNum == 1">1</span>
                  <span class="circle_icon" v-else><i class="el-icon-check"></i></span>
                  第一步 筛选任务条件
                </div>
                <div class="to_next"><i class="el-icon-arrow-right"></i></div>
                <div class="top_step_item" :class="{'step2': stepNum != 2,'step4': stepNum == 2}" @click="stepNum = 2">
                  <span class="circle_icon">2</span>
                  第二步 发送短信编辑
                </div>
              </div>-->
              <div class="top_step">
                <div class="top_step_item step1">
                  <span class="circle_icon" v-if="stepNum == 1">1</span>
                  第一步 筛选任务条件
                </div>
                <div class="to_next">
                  <i class="el-icon-arrow-right"></i>
                </div>
                <div class="top_step_item step2">
                  <span class="circle_icon">2</span>
                  第二步 发送短信编辑
                </div>
              </div>

              <!--活动名称:-->
              <template v-if="menuType == 9">
                <div class="right-content" style="margin-top: 40px">
                  <div class="right-content-left" style="margin-right: 8px">
                    活动名称:
                  </div>
                  <div class="right-content-right">
                    <el-input
                      v-model="postForm.taskName"
                      placeholder="请输入活动名称"
                      size="small"
                      style="width: 588px"
                      maxlength="30"
                      show-word-limit
                    ></el-input>
                  </div>
                </div>
              </template>

              <!--任务名称:-->
              <template v-else>
                <div class="right-content" style="margin-top: 40px">
                  <div class="right-content-left" style="margin-right: 8px">
                    任务名称:
                  </div>
                  <div class="right-content-right">
                    <el-input
                      v-model="postForm.taskName"
                      placeholder="请输入任务名称"
                      size="small"
                      style="width: 588px"
                      maxlength="30"
                      show-word-limit
                    ></el-input>
                  </div>
                </div>
              </template>

              <!--活动时间-->
              <!-- <template v-if="menuType == 9">
                <div class="right-content">
                  <div class="right-content-left" style="margin-right: 8px">
                    活动时间:
                  </div>
                  <div class="right-content-right" style="line-height: 32px">
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="postForm.taskStartTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 170px"
                        class="time1"
                        :clearable="false"
                        @change="moneyPayTimeChange"
                      ></el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="postForm.taskEndTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 165px"
                        class="time2"
                        :clearable="false"
                        @change="moneyPayTimeChange"
                      ></el-date-picker>
                      <i
                        class="el-icon-circle-close date_icon1"
                        @click="clearTime"
                      ></i>
                      <img
                        src="@/assets/images/select_date.svg"
                        alt
                        class="date_icon2"
                      />
                    </div>
                  </div>
                </div>
              </template> -->
              <!--任务时间-->
              <template>
                <div class="right-content">
                  <div class="right-content-left" style="margin-right: 8px">
                    任务时间:
                  </div>
                  <div class="right-content-right" style="line-height: 32px">
                    <el-radio-group v-model="postForm.taskType">
                      <el-radio :label="0">
                        <span>持续开启</span>
                      </el-radio>
                      <el-radio :label="1">
                        <span>指定时间</span>
                      </el-radio>
                    </el-radio-group>
                    <!-- <el-date-picker
                        v-if="postForm.taskType===1"
                        v-model="taskTimeChange"
                        type="datetimerange"
                        :clearable="false"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        size="small"
                        style="margin-left:10px;"
                    ></el-date-picker>-->

                    <div class="my_select_time" v-if="postForm.taskType === 1">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="postForm.taskStartTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 120px; margin-left: 10px; font-size: 12px"
                        class="time1"
                        :clearable="false"
                        @change="moneyPayTimeChange"
                      ></el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="postForm.taskEndTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 145px; font-size: 12px"
                        class="time2"
                        :clearable="false"
                        @change="moneyPayTimeChange"
                      ></el-date-picker>
                      <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
                      <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
                    </div>
                  </div>
                </div>
              </template>

              <!--活动码-->
              <template v-if="menuType == 9">
                <div class="right-content">
                  <div class="right-content-left" style="margin-right: 8px">
                    活动码:
                  </div>
                  <div class="right-content-right" style="line-height: 32px">
                    <span class="activityNum" :style="'border: 1px solid ' + changeColor">
                      共
                      <span :style="'color:' + changeColor">{{ postForm.activityCodeNum }}</span
                      >个活动码
                    </span>
                    <el-upload
                      class="upload-demo"
                      action="/jd-yusms/activityCodeConfig/importActivityCode"
                      :multiple="false"
                      :show-file-list="false"
                      :limit="1"
                      ref="upload"
                      :http-request="uploadSectionFile"
                      :on-exceed="handleExceed"
                      :on-success="handleAvatarSuccess"
                      :on-error="uploadError"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <div
                      @mouseenter="enter()"
                      @mouseleave="leave()"
                      style="
                        position: relative;
                        margin-left: 14px;
                        display: inline-block;
                      "
                    >
                      <span class="tips" :style="'color:' + changeColor + ';border-bottom: 1px solid ' + changeColor">查看示例</span>
                      <div class="exampleImg" :style="{ display: imgDisplay }"></div>
                    </div>
                  </div>
                </div>
              </template>

              <!--发送时间-->
              <div class="right-content">
                <div class="right-content-left" style="margin-right: 8px">
                  发送时间:
                </div>
                <div class="right-content-right">
                  <template v-if="menuType == 9">
                    <el-select v-model="postForm.activitySendTimeType" placeholder="请选择" size="small" style="width: 146px">
                      <el-option label="卖家发货后发送" value="1"></el-option>
                      <el-option label="卖家付款后发送" value="2"></el-option>
                      <el-option label="交易订单完成后发送" value="3"></el-option>
                    </el-select>
                    <el-tooltip class="item" effect="light" content="买家付款后包括货到付款" placement="top-start">
                      <span class="question_icon">?</span>
                    </el-tooltip>
                  </template>
                  <!-- 商品复购 -->
                  <template v-if="menuType == 1">
                    <el-radio-group v-model="postForm.warePeriodType" @change="wareType">
                      <el-radio :label="1">
                        <span style="padding: 0 16px 0 0">回购型</span>
                        <span>商品消耗完</span>
                        <el-select
                          v-model="postForm.wareConsumeType"
                          @change="wareChange"
                          placeholder="请选择"
                          size="small"
                          style="width: 76px; margin: 0 6px"
                        >
                          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <el-input
                          size="small"
                          v-if="+postForm.wareConsumeType !== 0"
                          style="width: 56px"
                          maxlength="10"
                          @blur="sendConditionTips"
                          v-model="postForm.sendConditionDay"
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        ></el-input>
                        <span>天发送短信（订单完成后计算时间）。每天</span>
                        <el-input
                          size="small"
                          style="width: 50px; margin: 0 6px"
                          maxlength="10"
                          v-if="postForm.warePeriodType == 1"
                          @blur="sendConditionTips"
                          v-model="postForm.sendConditionHour"
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        ></el-input>
                        <el-input
                          size="small"
                          style="width: 50px; margin: 0 6px"
                          maxlength="10"
                          v-if="postForm.warePeriodType == 2"
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        ></el-input>
                        <span>时发送短信</span>
                      </el-radio>

                      <br />
                      <el-radio :label="2">
                        <span style="padding: 0 16px 0 0">推荐型</span>
                        <span>到商品推荐周期立即发送短信（订单完成后计算时间）。每天</span>
                        <el-input
                          size="small"
                          style="width: 50px; margin: 0 6px"
                          maxlength="10"
                          @blur="sendConditionTips"
                          v-model="postForm.sendConditionHour"
                          v-if="postForm.warePeriodType == 2"
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        ></el-input>
                        <el-input
                          size="small"
                          style="width: 50px; margin: 0 6px"
                          maxlength="10"
                          v-if="postForm.warePeriodType == 1"
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                        ></el-input>
                        <span>时发送短信</span>
                      </el-radio>
                    </el-radio-group>
                  </template>

                  <template v-else-if="menuType == 2 || menuType == 3">
                    <el-radio-group v-model="postForm.sendOpportunity">
                      <el-radio :label="1">
                        <span>付款时立即发送</span>
                      </el-radio>
                      <el-radio :label="2">
                        <span>完成订单立即发送</span>
                      </el-radio>
                    </el-radio-group>
                  </template>
                  <template v-else-if="menuType == 4">
                    <span>距离最后一次付款</span>
                    <el-input
                      v-model="postForm.sendDays"
                      size="small"
                      style="width: 50px"
                      @keyup.native="filNumber"
                      maxlength="10"
                      @blur="sendConditionTips"
                    ></el-input>
                    <span style="padding-left: 10px">天后未复购发送短信，每天</span>
                    <el-input
                      v-model="postForm.sendTime"
                      size="small"
                      style="width: 50px"
                      @keyup.native="filNumber"
                      maxlength="10"
                      @blur="sendConditionTips"
                    ></el-input>
                    <span>时发送短信</span>
                  </template>

                  <!-- 会员账单 -->
                  <template v-if="menuType == 8">
                    <span>每月</span>
                    <el-input
                      v-model="postForm.sendDays"
                      size="small"
                      style="width: 50px"
                      @keyup.native="filNumber"
                      maxlength="10"
                      @blur="sendConditionTips"
                    ></el-input>
                    <span>日</span>
                    <el-input
                      v-model="postForm.sendTime"
                      size="small"
                      style="width: 50px"
                      @keyup.native="filNumber"
                      maxlength="10"
                      @blur="sendConditionTips"
                    ></el-input>
                    <span>点</span>
                  </template>
                  <template v-if="menuType == 5 || menuType == 6 || menuType == 7">
                    <el-select v-model="postForm.sendUnitTime3" placeholder="请选择" size="small" style="width: 136px; margin: 0 6px">
                      <el-option v-for="item in optionsMouth" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <span v-if="menuType == 5">满30天，</span>
                    <span v-if="menuType == 6">满100天，</span>
                    <span v-if="menuType == 7">满1周年，</span>
                    <span>发送短信。每天</span>
                    <el-input
                      size="small"
                      style="width: 50px; margin: 0 6px"
                      @keyup.native="filNumber"
                      maxlength="10"
                      @blur="sendConditionTips"
                      v-model="postForm.sendTime"
                    ></el-input>
                    <span>时发送短信</span>
                  </template>
                </div>
              </div>
              <!--发送时段-->
              <div class="right-content" v-if="menuType != 1 && menuType != 5 && menuType != 4 && menuType != 6 && menuType != 7 && menuType != 8">
                <div class="right-content-left">发送时段:</div>
                <div class="right-content-right">
                  <span>每天</span>
                  <el-time-picker
                    class="time"
                    v-model="postForm.startRemindTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    size="small"
                    style="width: 100px; margin-left: 16px"
                  ></el-time-picker>
                  <!-- <el-time-select
                  class="pickerTime"
                    v-model="postForm.startRemindTime"
                    :picker-options="{
                      start: '00:00',
                      step: '01:00',
                      end: '23:00',
                    }"
                    placeholder="选择时间"
                    size="small"
                    style="width: 100px; margin-left: 12px"
                  ></el-time-select> -->
                  <span>&nbsp; 至 &nbsp;</span>
                  <!-- <el-time-picker
                      style="width: 100px;margin-left: 12px;"
                      v-model="postForm.startRemindTime"
                      :format="'HH:mm'"
                      :clearable="false"
                      @change="remindTimeTips"
                      placeholder="选择时间"
                    ></el-time-picker>
                    <span>&nbsp; 至 &nbsp;</span>
                    <el-time-picker
                      :clearable="false"
                      v-model="postForm.endRemindTime"
                      :format="'HH:mm'"
                      placeholder="选择时间"
                      :picker-options="{selectableRange:this.maxStartRemindTime + ' - 23:59:59'}"
                      style="width: 100px;"
                  ></el-time-picker>-->
                  <el-time-picker
                    class="time"
                    v-model="postForm.endRemindTime"
                    format="HH:mm"
                    value-format="HH:mm"
                    size="small"
                    style="width: 100px"
                  ></el-time-picker>
                  <!-- <el-time-select
                  class="pickerTime"
                    v-model="postForm.endRemindTime"
                    :picker-options="{
                      start: '00:00',
                      step: '01:00',
                      end: '23:00',
                    }"
                    placeholder="选择时间"
                    size="small"
                    style="width: 100px"
                  ></el-time-select> -->
                  <span>&nbsp;&nbsp; 时，发送短信。其他时间 &nbsp;</span>
                  <template v-if="menuType == 9">
                    <span>不发送</span>
                  </template>
                  <!-- 选择发送段 -->
                  <template v-else>
                    <el-select v-model="postForm.remindSendType" placeholder="请选择" size="small" style="width: 136px; margin-left: 6px">
                      <el-option v-for="item in optionsTwo" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </template>

                  <div style="margin-top: 10px">
                    <el-checkbox v-model="postForm.isLunchBreak">
                      <span>午休时间 &nbsp;</span>
                    </el-checkbox>
                    <el-time-picker
                      class="time"
                      v-model="postForm.startLunchBreak"
                      format="HH:mm"
                      value-format="HH:mm"
                      :picker-options="{
                        selectableRange: '09:00:00 - 22:00:00',
                      }"
                      placeholder="选择时间"
                      size="small"
                      style="width: 100px"
                    ></el-time-picker>
                    <!-- <el-time-select
                    class="pickerTime"
                      v-model="postForm.startLunchBreak"
                      :picker-options="{
                        start: '07:00',
                        step: '01:00',
                        end: '22:00',
                      }"
                      placeholder="选择时间"
                      size="small"
                      style="width: 100px"
                    ></el-time-select> -->
                    <span>&nbsp; 至 &nbsp;</span>
                    <el-time-picker
                      class="time"
                      v-model="postForm.endLunchBreak"
                      format="HH:mm"
                      value-format="HH:mm"
                      :picker-options="{
                        selectableRange: '09:00:00 - 20:00:00',
                      }"
                      placeholder="选择时间"
                      size="small"
                      style="width: 100px"
                    ></el-time-picker>
                    <!-- <el-time-select
                    class="pickerTime"
                      v-model="postForm.endLunchBreak"
                      :picker-options="{
                        start: '07:00',
                        step: '01:00',
                        end: '22:00',
                        minTime: postForm.startLunchBreak,
                      }"
                      placeholder="选择时间"
                      size="small"
                      style="width: 100px"
                    ></el-time-select> -->
                    <span>&nbsp;&nbsp; 不发送，向后顺延 &nbsp;</span>
                  </div>
                </div>
              </div>

              <!--发送条件:-->
              <div class="right-content" v-if="menuType !== 1 && menuType !== 4">
                <div class="right-content-left" style="margin-right: 8px">
                  发送条件:
                </div>

                <div class="right-content-right" v-if="menuType != 9">
                  <div>
                    <el-checkbox v-model="postForm.isOrderMoney">
                      <span>截止发送时间累积实付金额 &nbsp;&nbsp;</span>
                    </el-checkbox>
                    <el-input
                      v-model="postForm.startOrderMoney"
                      placeholder="0"
                      size="small"
                      style="width: 125px"
                      maxlength="15"
                      @change="moneyChange1"
                      class="color_gray"
                    >
                      <!-- @keyup.native="
                        postForm.startOrderMoney = oninput(
                          postForm.startOrderMoney
                        )
                      " -->
                      <template slot="suffix">
                        <span>元</span>
                      </template>
                    </el-input>
                    <span>&nbsp; 至 &nbsp;</span>
                    <el-input
                      v-model="postForm.endOrderMoney"
                      placeholder="100"
                      size="small"
                      style="width: 125px"
                      maxlength="15"
                      class="color_gray"
                      @change="moneyChange1"
                    >
                      <!-- @keyup.native="
                        postForm.endOrderMoney = oninput(postForm.endOrderMoney)
                      " -->
                      <template slot="suffix">
                        <span>元</span>
                      </template>
                    </el-input>
                  </div>
                  <div style="margin-top: 10px; margin-left: 8px; overflow: hidden" v-if="menuType == 3 || menuType == 8">
                    <el-checkbox v-model="postForm.dealCount">
                      <span>截止发送时间累积交易次数 &nbsp;&nbsp;</span>
                    </el-checkbox>
                    <el-input
                      v-model="postForm.startBuyTotalCount"
                      placeholder="0"
                      size="small"
                      style="width: 125px"
                      maxlength="15"
                      class="color_gray"
                      @change="moneyChange"
                    >
                      <template slot="suffix">
                        <span>次</span>
                      </template>
                    </el-input>
                    <span>&nbsp; 至 &nbsp;</span>
                    <el-input
                      v-model="postForm.endBuyTotalCount"
                      placeholder="100"
                      size="small"
                      style="width: 125px"
                      maxlength="15"
                      class="color_gray"
                      @change="moneyChange"
                    >
                      <template slot="suffix">
                        <span>次</span>
                      </template>
                    </el-input>
                  </div>
                  <template v-if="menuType != 2 && menuType != 3 && menuType != 8">
                    <div style="margin-top: 10px; overflow: hidden">
                      <el-checkbox v-model="postForm.isProductNum">
                        <span>商品数量 &nbsp;&nbsp;</span>
                      </el-checkbox>
                      <div style="display: inline-block; position: relative">
                        <el-input
                          type="number"
                          v-model="postForm.startProductNum"
                          placeholder
                          @change="changeTotalMoneyStart"
                          size="small"
                          style="width: 125px; position: relative"
                          maxlength="8"
                          class="color_gray"
                        >
                          <template slot="suffix">
                            <span>件</span>
                          </template>
                        </el-input>
                      </div>
                      <span>&nbsp; 至 &nbsp;</span>
                      <div style="display: inline-block; position: relative">
                        <el-input
                          type="number"
                          v-model="postForm.endProductNum"
                          @change="changeTotalMoneyEnd"
                          placeholder
                          size="small"
                          maxlength="8"
                          style="width: 125px; position: relative"
                          class="color_gray"
                        >
                          <template slot="suffix">
                            <span>件</span>
                          </template>
                        </el-input>
                      </div>
                    </div>
                    <div style="margin-top: 10px; overflow: hidden">
                      <el-checkbox v-model="postForm.isSellerRemark">
                        <span>商家备注包含</span>
                      </el-checkbox>
                      <el-input
                        v-model="postForm.sellerRemark"
                        placeholder="多关键词用“，”分开"
                        size="small"
                        style="width: 280px; margin: 0 8px"
                        maxlength="200"
                      ></el-input>
                      <el-select v-model="postForm.isSellerRemarkSend" placeholder="请选择" size="small" style="width: 136px">
                        <el-option v-for="item in sendOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>

                      <el-tooltip
                        class="item"
                        effect="light"
                        content="买家留言和卖家备注关键字至少15个字以内，输入框最多输入200个字以内，多个用“，”替换"
                        placement="top-start"
                      >
                        <span class="question_icon">?</span>
                      </el-tooltip>
                      <!-- </el-radio> -->
                    </div>
                    <div style="margin-top: 10px; overflow: hidden">
                      <el-checkbox v-model="postForm.isBuyerMessage">
                        <span>买家备注包含</span>
                      </el-checkbox>
                      <el-input
                        v-model="postForm.buyerMessage"
                        placeholder="多关键词用“，”分开"
                        size="small"
                        style="width: 280px; margin: 0 8px"
                        maxlength="200"
                      ></el-input>
                      <!--  -->
                      <el-select v-model="postForm.isBuyerMessageSend" placeholder="请选择" size="small" style="width: 136px">
                        <el-option v-for="item in sendOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                      <el-tooltip
                        class="item"
                        effect="light"
                        content="买家留言和卖家备注关键字至少15个字以内，输入框最多输入200个字以内，多个用“，”替换"
                        placement="top-start"
                      >
                        <span class="question_icon">?</span>
                      </el-tooltip>
                    </div>
                  </template>
                </div>
                <template v-if="menuType == 9">
                  <div class="right-content-right">
                    <div>
                      <el-checkbox v-model="postForm.isOrderMoney">
                        <span>实付金额达到 &nbsp;&nbsp;</span>
                      </el-checkbox>
                      <el-input
                        v-model="postForm.startOrderMoney"
                        placeholder="0"
                        size="small"
                        style="width: 125px"
                        maxlength="15"
                        class="color_gray"
                        @keyup.native="postForm.startOrderMoney = oninput(postForm.startOrderMoney)"
                      >
                        <template slot="suffix">
                          <span>元</span>
                        </template>
                      </el-input>
                      <span>&nbsp; 至 &nbsp;</span>
                      <el-input
                        v-model="postForm.endOrderMoney"
                        placeholder="100"
                        size="small"
                        style="width: 125px"
                        maxlength="15"
                        class="color_gray"
                        @keyup.native="postForm.endOrderMoney = oninput(postForm.endOrderMoney)"
                      >
                        <template slot="suffix">
                          <span>元</span>
                        </template>
                      </el-input>
                      <el-tooltip class="item" effect="light" content="不勾选则是任意金额" placement="top-start">
                        <span class="question_icon">?</span>
                      </el-tooltip>
                    </div>
                    <div v-if="postForm.isAllItem == 1" style="margin-top: 10px; overflow: hidden">
                      <el-checkbox v-model="postForm.isProductNum">
                        <span>商品数量 &nbsp;&nbsp;</span>
                      </el-checkbox>
                      <div style="display: inline-block; position: relative">
                        <el-input
                          type="number"
                          v-model="postForm.startProductNum"
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          placeholder
                          size="small"
                          style="width: 125px; position: relative"
                          maxlength="8"
                          class="color_gray"
                        >
                          <template slot="suffix">
                            <span>件</span>
                          </template>
                        </el-input>
                      </div>
                      <span>&nbsp; 至 &nbsp;</span>
                      <div style="display: inline-block; position: relative">
                        <el-input
                          type="number"
                          v-model="postForm.endProductNum"
                          oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                          placeholder
                          size="small"
                          maxlength="8"
                          style="width: 125px; position: relative"
                          class="color_gray"
                        >
                          <template slot="suffix">
                            <span>件</span>
                          </template>
                        </el-input>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <!-- 提醒等级 -->
              <div class="right-content" v-if="menuType == 8">
                <div class="right-content-left" style="margin-right: 8px">
                  提醒等级:
                </div>
                <div class="right-content-right">
                  <el-checkbox v-model="postForm.RemindLevel" label="1">
                    <span>一星会员</span>
                  </el-checkbox>
                  <el-checkbox v-model="postForm.RemindLevel" label="2">
                    <span>二星会员</span>
                  </el-checkbox>
                  <el-checkbox v-model="postForm.RemindLevel" label="3">
                    <span>三星会员</span>
                  </el-checkbox>
                  <el-checkbox v-model="postForm.RemindLevel" label="4">
                    <span>四星会员</span>
                  </el-checkbox>
                  <el-checkbox v-model="postForm.RemindLevel" label="5">
                    <span>五星会员</span>
                  </el-checkbox>
                </div>
              </div>
              <!-- 运单号 -->
              <div
                class="right-content"
                v-if="menuType != 1 && menuType != 2 && menuType != 3 && menuType != 4 && menuType != 8 && menuType != 9 && menuType != 10"
              >
                <div class="right-content-left" style="margin-right: 8px">
                  运单号:
                </div>
                <div class="right-content-right">
                  <el-radio v-model="postForm.shipmentNum" label="0">
                    <span>全部发送</span>
                  </el-radio>
                  <el-radio v-model="postForm.shipmentNum" label="1">
                    <span>不发送有运单号订单</span>
                  </el-radio>
                  <el-radio v-model="postForm.shipmentNum" label="2">
                    <span>不发送无运单号订单</span>
                  </el-radio>
                </div>
              </div>
              <!--订单类型:-->
              <!-- <div
                  class="right-content"
                  v-if="menuType!=1 && menuType!=2 && menuType!=3 && menuType!=4 && menuType!=8 && menuType!=9 && menuType!=13"
                >
                  <div class="right-content-left">订单类型:</div>
                  <div class="right-content-right">
                    <el-radio v-model="postForm.orderType" label="0">
                      <span>全部</span>
                    </el-radio>
                    <el-radio
                      v-model="postForm.orderType"
                      label="1"
                    >
                      <span>预售</span>
                    </el-radio>
                    <el-radio v-model="postForm.orderType" label="2" style="margin-right: 8px;">
                      <span>非预售</span>
                      <el-select
                        v-model="postForm.presellType"
                        placeholder="请选择"
                        size="small"
                        style="width: 105px;margin-left: 8px;vertical-align: bottom;"
                        v-if="postForm.orderType == 1 && menuType==3"
                      >
                        <el-option
                          v-for="item in optionsThree"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-radio>
                  </div>
              </div>-->

              <!--付款类型:-->
              <!-- <div
                  class="right-content"
                  v-if="menuType==6 || menuType==7"
                >
                  <div class="right-content-left">付款类型:</div>
                  <div class="right-content-right">
                    <el-radio v-model="postForm.moneyType" :label="item.value" v-for="(item,index) in moneyTypeList" :key="index">
                      <span>{{item.label}}</span>
                    </el-radio>
                  </div>
              </div>-->

              <!-- 付款方式 -->
              <div class="right-content" v-if="menuType != 1 && menuType != 2 && menuType != 3 && menuType != 8 && menuType != 4">
                <div class="right-content-left" style="margin-right: 8px">
                  不发送付款方式:
                </div>
                <div class="right-content-right">
                  <div>
                    <el-checkbox-group v-model="postForm.payType" @change="filterCondiions">
                      <el-checkbox :label="item.value" v-for="(item, index) in payTypeList" :key="index">
                        <span>{{ item.label }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </div>
              <!-- <div class="right-content">
                <div class="right-content-left" style="margin-right: 8px">
                  发送人数:
                </div>
                <div class="right-content-right">
                  <el-radio-group v-model="postForm.limitSendNum">
                    <el-radio :label="false">不限制</el-radio>
                  
                    <el-radio :label="true">
                      限制发送数
                      <el-input
                        :disabled="!postForm.limitSendNum"
                        style="width: 68px; margin-right: 8px"
                        oninput="value=value.replace(/^\.+|[^\d]/g,'')"
                        v-model="postForm.sendNum"
                      ></el-input>
                      <el-tooltip class="item" effect="light"  placement="right-start">
                        <div slot="content" style="color:#666; font-size:12px">
                          <div style="margin-bottom:5px">设置该任务每天发送人数的上限</div>
                          </div>
                        <div class="explain">?</div>
                      </el-tooltip>

                    </el-radio>
                  </el-radio-group>
                </div>
              </div> -->
              <!--过滤设置:-->
              <div class="right-content">
                <div class="right-content-left" style="margin-right: 8px">
                  过滤设置:
                </div>
                <div class="right-content-right">
                  <div  :style="menuType == 1 ? 'width: 440px; display: inline-block;': ''">
                    <el-checkbox-group v-model="postForm.filterCondition" @change="filterCondiions">
                      <!-- <el-checkbox
                        label="0"
                        v-if="menuType == 5 || menuType == 6 || menuType == 7"
                      >
                        <span>同1个买家1天只提醒一次</span>
                      </el-checkbox> -->
                      <el-checkbox label="1">
                        <span>屏蔽黑名单</span>
                        <!-- :style="{ color: changeColor }" -->
                        <span @click="routerLinkOne()" style="margin-left: 10px; color: #7f85e9">设置黑名单</span>
                      </el-checkbox>
                      <el-checkbox label="2" v-if="menuType == 1">
                        <span>过滤周期内有购买原商品客户</span>
                      </el-checkbox>
                      <template v-if="menuType == 9">
                        <el-checkbox label="4">
                          <span>同1买家，仅限参与</span>
                          <el-input
                            style="width: 80px; padding: 0 8px"
                            @keyup.native="postForm.participationNumber = oninput(postForm.participationNumber)"
                            v-model="postForm.participationNumber"
                          ></el-input>
                          <span>次</span>
                          <el-tooltip class="item" effect="light" content="不勾选表示不限次数参加" placement="top-start">
                            <span class="question_icon">?</span>
                          </el-tooltip>
                        </el-checkbox>
                      </template>
                    </el-checkbox-group>
                  </div>
                  <div style="width: 300px; display: inline-block;">
                    <template v-if="menuType == 1">
                      <el-checkbox v-model="postForm.isFilterFreeGoods" @change="changeisFilterFreeGoods" :label="'12345'" >
                        <span>过滤赠送商品</span>
                      </el-checkbox>
                      <span style="margin-left: 8px;">
                        <el-tooltip
                          placement="top"
                          effect="light"
                          trigger="hover"
                          content="选中后，则会过滤指定商品中作为赠品赠送的商品订单"
                        >
                          <i
                            class="el-icon-question"
                            :style="actIcon ? 'color: red' : ''"
                            @mouseover="actIcon = true"
                            @mouseleave="actIcon = false"
                          ></i>
                        </el-tooltip>
                      </span>
                    </template>
                  </div>
                </div>
              </div>

              <!-- Note-----会员筛选条件 -->
              <div class="right-content">
                  <div class="right-content-left"  style="margin-left:10px">会员筛选：</div>
                  <div class="right-content-right">
                    <el-radio v-model="postForm.memberSelect" label="0">
                      <span>全部</span>
                    </el-radio>
                    <el-radio v-model="postForm.memberSelect" label="1">
                      <span>只发送会员</span>
                    </el-radio>
                    <el-radio v-model="postForm.memberSelect" label="2">
                      <span>只发送非会员</span>
                    </el-radio>
                  </div>
                </div>
                <div class="right-content" v-if="postForm.memberSelect == 1">
                  <div class="right-content-left"></div>
                  <div class="right-content-right"> 
                    <el-checkbox-group
                      v-model="postForm.memberSelectLevel"
                      @change="handleSelectLevel"
                    >
                      <el-checkbox
                        v-for="item in memberLevelOptions"
                        :label="item.value"
                        :key="item.value"
                        @change="changeMemberLevels(item.value)"
                      >
                        <span>{{ item.name }}</span>
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>

              <!--选择地区：-->
              <div class="right-content" v-if="menuType != 1 && menuType != 2 && menuType != 3 && menuType != 8 && menuType != 9">
                <div class="right-content-left">选择地区:</div>
                <div class="right-content-right">
                  <div class="bb" style="width: 560px">
                    <el-radio
                      v-model="postForm.areaType"
                      v-for="item in areaData"
                      :key="item.value"
                      :label="item.value"
                      @change="customArea(item.value)"
                    >
                      <span>{{ item.name }}</span>
                    </el-radio>
                    <div class="button" @click="popupShowBtn()">
                      已选择
                      <span :style="{ color: '#7f85e9' }">{{ checkedList | getCityLength }}</span>
                      个
                    </div>
                  </div>
                </div>
              </div>
              <!--选择地区:-->
              <div class="right-content" v-if="menuType == 9">
                <div class="right-content-left" style="margin-right: 8px">
                  选择地区:
                </div>
                <div class="right-content-right">
                  <div class="bb" style="width: 320px">
                    <el-radio v-model="postForm.areaType" label="0" @change="customArea">
                      <span>不限</span>
                    </el-radio>
                    <el-radio v-model="postForm.areaType" label="3" @change="customArea(3)">
                      <span>自定义</span>
                    </el-radio>
                    <div class="yixuanzhe_button" @click="popupShowBtn()">
                      已选择
                      <span :style="{ color: changeColor }">{{ checkedList | getCityLength }}</span>
                      个
                    </div>
                  </div>
                </div>
              </div>

              <!--选择商品-->
              <div class="right-content" v-if="menuType != 8 && menuType != 4 && menuType != 9">
                <div class="right-content-left" style="margin-right: 8px">
                  选择商品:
                </div>

                <div class="right-content-right">
                  <template v-if="menuType == 1">
                    <div class="bb" style="width: 420px; overflow: hidden">
                      <div class="sku_button" style="float: left" @click="(goodsState3 = true), (GoodsSkuIsflay = false)">
                        选择SKU （已选择
                        <span style="color: #fe4d45">
                          {{ goodsStateLength }}
                        </span>
                        个）
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="bb" style="width: 420px">
                      <el-radio-group v-model="postForm.isAllItem" @change="selGoods">
                        <el-radio v-for="item in shoppingData" :key="item.name" :label="item.value">
                          <span>{{ item.name }}</span>
                        </el-radio>
                      </el-radio-group>
                      <div v-show="isShowSelectGoods" class="yixuanzhe_button" @click="showSelectGoods">
                        已选择
                        <span :style="{ color: changeColor }">{{ goodsStateLength }}</span>
                        个
                      </div>
                    </div>
                  </template>
                </div>
                <div v-if="menuType == 1" class="table">
                  <el-table
                    :data="tableList"
                    style="width: 100%; margin-top: 22px"
                    :header-cell-style="{
                      background: '#fafafa',
                      'text-align': 'left',
                    }"
                    :cell-style="{ 'text-align': 'left' }"
                  >
                    <el-table-column prop="wareTitle" label="商品名称/SKU"></el-table-column>
                    <el-table-column prop="price" width="100" label="价格"></el-table-column>
                    <el-table-column :label="postForm.warePeriodType == 1 ? '单个回购周期' : '推荐周期'">
                      <template slot-scope="scope">
                        <el-input class="cycleInput" v-if="scope.row.isEdit" v-model="scope.row.periodDay"></el-input>
                        <span v-else>{{ scope.row.periodDay }}</span>
                        <span>天</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button v-show="!scope.row.isEdit" @click="editOrderCare(scope.row)" type="text" class="edit_btn">修改</el-button>
                        <el-button v-show="scope.row.isEdit" @click="editOrderCare(scope.row)" type="text" class="edit_btn">确定</el-button>
                        <el-button @click="onDefault(scope.row)" type="text" class="del_btn">恢复默认</el-button>
                        <el-button @click="deleteOrderCare(scope.row)" type="text" class="del_btn">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <!--选择商品-->
              <div class="right-content" v-if="menuType == 9">
                <div class="right-content-left">选择商品:</div>
                <div class="right-content-right">
                  <div class="bb" style="width: 320px">
                    <el-radio-group v-model="postForm.isAllItem" @change="selGoods">
                      <!-- <el-radio v-for="item in shoppingData" :key="item.name" :label="item.value">
                          <span>{{item.name}}</span>
                      </el-radio>-->
                      <el-radio label="0">
                        <span>全部商品</span>
                      </el-radio>
                      <el-radio label="1">
                        <span>指定商品</span>
                      </el-radio>
                    </el-radio-group>
                    <div v-show="isShowSelectGoods" class="yixuanzhe_button" @click="showSelectGoods">
                      已选择
                      <span :style="{ color: changeColor }">{{ goodsStateLength }}</span>
                      个
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- 发送上限 -->
              <div class="right-content">
                <div class="right-content-left" style="margin-left:10px">发送上限：</div>
                <div class="right-content-right">
                  <span>每日发送量达到</span>&nbsp;
                  <el-input v-model="postForm.dayLimit" size="small" @keyup.native="limitInput1" style="width: 100px" ></el-input>&nbsp;
                  <span>时不发送</span>   
                </div>
              </div>
              <div v-show="menuType == 8" style="height: 300px"></div>
              <div class="next_box" :style="{ 'margin-top': menuType == 8 ? '80px' : '' }">
                <div class="next" @click="nextBtn()">下一步</div>
              </div>

              <!--第二部-->
              <el-drawer
                :withHeader="false"
                :show-close="false"
                :append-to-body="true"
                :before-close="handleClose2"
                :visible.sync="innerDrawer"
                custom-class="inner_Drawer"
                :size="'1100px'"
              >
                <div
                  class="box-conten-small myTwo"
                  key="1547"
                  style="
                    background: #fff;
                    z-index: 9 !important;
                    position: relative;
                    height: 100%;
                  "
                >
                  <div>
                    <span class="page_title">创建任务</span>
                    <span @click="backOne" class="del_icon">x</span>
                  </div>
                  <div class="top_step">
                    <div class="top_step_item step3" :class="{ '': stepNum != 1 }">
                      <span class="circle_icon">
                        <i class="el-icon-check"></i>
                      </span>
                      第一步 筛选任务条件
                    </div>
                    <div class="to_next">
                      <i class="el-icon-arrow-right"></i>
                    </div>
                    <div class="top_step_item step4">
                      <span class="circle_icon">2</span>
                      第二步 发送短信编辑
                    </div>
                  </div>

                  <div class="two-content" style="position: relative">
                    <div style="padding: 72px 0; margin: 0 0 100px 0">
                      <!-- 温馨提示 -->
                      <div class="topTis top_bg" style="width:630px" v-if="isOfficial">
                        <!-- <i class="el-icon-warning" style="color: #FE8F8A; marginRight: 8px;"></i> -->
                        <img
                          src="@/assets/images/new_icon_reminder.png"
                          style="
                            display: inline-block;
                            float: left;
                            width: 14px;
                            position: absolute;
                            height: 14px;
                            color: rgb(255, 255, 255);
                            margin: 2px 0px 0px 0;
                          "
                        />
                        <div class="desc" style="background: transparent">
                          <p>
                            1.此功能是京东官方功能，发送短信需使用官方模板，不支持手动编辑；
                          </p>
                          <p>
                            2.短信内容中含变量标签时,发送时平台会自动替换为实际信息；
                          </p>
                          <p>
                            3.后台管理-短信模板，可自行申请官方模板，官方审核通过后即可使用。
                          </p>
                          <p v-if="longlinkFlay" style="color:#d9001b;word-wrap: break-word;word-break: break-all;">4.模板中自定义链接的原网址绑定为: {{ this.longUrllink }}</p>
                          <p v-if="longlinkFlay" style="word-wrap: break-word;word-break: break-all;max-width: 500px;">
                          5.原始链接域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，转换后短链及前后空格占17字，点击可直接唤醒app。其它域名转换后的短链及前后空格占15字，且不可直接唤醒app
                        </p>
                        </div>
                      </div>
                      <div class="two-item">
                        <div class="item-left" style="margin-right: 8px">
                          编辑短信：
                        </div>
                        <!-- 短信发送编辑走官方 -->
                        <div class="item-right" v-if="isOfficial">
                          <div class="write-message-box">
                            <div class="message-content-box">
                              <div class="message-input-box" style="color: red">
                                <div class="sms-content-x">
                                  <div v-html="smsContent2html(inputContent)"></div>
                                </div>
                              </div>
                            </div>
                            <div class="footInfo">
                              <div>
                                <button class="keep_button1" @click.prevent="templateShow = true">
                                  短信模板
                                </button>
                                <span>
                                  已输入
                                  <span :style="{ color: changeColor }">{{ sendInfoLength }}</span>
                                  个字(含签名及退订文字),预计
                                  <span :style="{ color: changeColor }">{{
                                    Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70)
                                  }}</span>
                                  条短信
                                </span>
                              </div>
                              <div class="ask-content">
                                <span
                                  style="
                                    font-weight: normal;
                                    margin-left: 8px;
                                    color: #6069ff;
                                  "
                                  >计费规则</span
                                >
                                <span class="question_icon" style="margin-left: 4px">?</span>
                                <div class="ask-icon-select">
                                  <div>
                                    1.70个字计1条短信，超过70字按照67字每条计费。
                                  </div>
                                  <div>
                                    2.一个汉字，字母或标点空格都算作一个字。
                                  </div>
                                  <div>
                                    3.带标签短信以实际发送为准，有可能超过默认字数。
                                  </div>
                                  <div>4."签名"与"拒收请回复R"包含在字数中。</div>
                                  <div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>
                                  <div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- end -->
                        <div class="item-right" v-if="!isOfficial">
                          <div class="write-message-box write-message-box2">
                            <div class="label">
                              <div
                                style="
                                  float: left;
                                  font-size: 14px;
                                  color: #333;
                                "
                              >
                                可选标签：
                              </div>
                              <div class="label_content">
                                <template v-for="(item, index) in smsLabel">
                                  <div @click="selectTagTap(item)" class="label_items" :key="index">
                                    {{ item }}
                                  </div>
                                </template>
                              </div>
                            </div>
                            <div class="message-content-box">
                              <div class="message-input-box" style="color: red">
                                <el-input
                                  type="textarea"
                                  :rows="7"
                                  maxlength="500"
                                  id="copyIndexInfo"
                                  @input="sendInfoText"
                                  @click.native="getFourIndex"
                                  ref="sendText"
                                  placeholder
                                  v-model="inputContent"
                                  class="send-textare"
                                ></el-input>
                              </div>
                            </div>

                            <div class="footInfo">
                              <div>
                                <button class="keep_button1" @click.prevent="templateShow = true">
                                  短信模板
                                </button>
                                <button class="keep_button2" @click.prevent="handleShowModule">
                                  保存模板
                                </button>
                                <span>
                                  已输入
                                  <span :style="{ color: changeColor }">{{ sendInfoLength }}</span>
                                  个字(含签名及退订文字),预计
                                  <span :style="{ color: changeColor }">{{
                                    Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70)
                                  }}</span>
                                  条短信
                                </span>
                              </div>
                              <div class="ask-content">
                                <span
                                  style="
                                    font-weight: normal;
                                    margin-left: 8px;
                                    color: #6069ff;
                                  "
                                  >计费规则</span
                                >
                                <span class="question_icon" style="margin-left: 4px">?</span>
                                <div class="ask-icon-select">
                                  <div>
                                    1.70个字计1条短信，超过70字按照67字每条计费。
                                  </div>
                                  <div>
                                    2.一个汉字，字母或标点空格都算作一个字。
                                  </div>
                                  <div>
                                    3.带标签短信以实际发送为准，有可能超过默认字数。
                                  </div>
                                  <div>4."签名"与"拒收请回复R"包含在字数中。</div>
                                  <div>5.短链及前后空格占17字或15字，插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字（具体见插入链接说明）</div>
                                  <div>6.含插入#评价链接#或#付款链接#短信变量，变量转换后，实际长度为15字。</div>
                                  <div>7.插入短网址的原始域名为item.m.jd.com/shop.m.jd.com/shopmember.m.jd.com时，短链转换后的字符数及前后空格占17字</div>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="message-tips-box" style="max-width:600px">
                              <div>
                                <img src="@/assets/images/tishi.png" />
                                <span>注:输入网址前、后加空格，否则无法正常打开！</span>
                              </div>
                              <div v-if="getInputFilterList&&getInputFilterList.length>0">
                                <img src="@/assets/images/tishi.png" />
                                <span>
                                  注:易被手机拦截内容:
                                  <span
                                    v-for="(item,index) in getInputFilterList"
                                    :key="index"
                                  >({{item.word}}，建议替换为:{{item.replace}})</span>
                                </span>
                              </div>
                            </div>-->
                          </div>
                        </div>
                      </div>
                      <div v-if="!isOfficial" class="topTis topTis2">
                        <img
                          src="@/assets/images/new_icon_reminder.png"
                          style="
                            display: inline-block;
                            float: left;
                            width: 14px;
                            height: 14px;
                            color: #ffffff;
                          "
                        />
                        <div class="desc">
                          <p>
                            (1)输入网址前、后加空格，否则无法正常打开；短链接建议实时转换生成，若使用复制粘贴链接，则无法统计点击转化数据;
                          </p>
                          <p>
                            (2)根据运营商规定，请不要发送“返现” “加微信”相关内容的短信；
                          </p>
                          <p>(3)短信内容请不要含有繁体字。</p>
                        </div>
                      </div>

                      <div class="two-item">
                        <div class="item-left" style="margin-right: 8px">
                          短信签名:
                        </div>
                        <div class="item-right">
                          <div style="width: 591px">
                            <div class="btnList">
                              <template v-for="(item, index) in suffixList">
                                <div class="btnBox" :key="index" @click="changeSufix(item)">
                                  <button
                                    class="btn"
                                    :class="{
                                      btn_active: item == selSuffixName,
                                    }"
                                    style="width: 100%"
                                  >
                                    {{ item }}
                                  </button>
                                  <span v-show="item == selSuffixName" class="check">
                                    <i class="el-icon-check"></i>
                                  </span>
                                </div>
                              </template>
                              <span style="fontsize: 14px; cursor: pointer" :style="{ color: changeColor }" @click="moreBtn()">更换</span>
                              <div></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="two-item" v-if="!isOfficial || longlinkFlay">
                        <div class="item-left" style="margin-right: 8px">
                          辅助工具:
                        </div>
                        <div class="item-right">
                          <div class="tool">
                            <p @click.prevent="insertShortUrlShow = true" style="line-height: 28px">
                              <i class="iconfont iconbtn_duanwangzhi" style="font-size: 14px; margin-right: 5px"></i>插入短网址
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="two-item">
                        <div class="item-left" style="margin-right: 8px">
                          <span style="display: inline-block;">短信测试:</span>
                        </div>
                        <div class="item-right">
                          <div class="input-box">
                            <!-- <el-input
                              size="small"
                              v-model="smsTestSendParams.mobiles"
                              style="width: 224px"
                              placeholder="输入测试号码"
                            ></el-input> -->
                            <el-select v-model="Selectmobiles" multiple collapse-tags placeholder="请选择" style="width: 264px;vertical-align: top;" @change="selectTestMobiles">
                                <el-option v-for="item in testOptions" :key="item" :label="item" :value="item"></el-option>
                            </el-select>
                          </div>
                          <div class="test-button1" @click="testSend">
                            发送短信测试
                          </div>
                          <div class="test-button1 test_button2" @click="smsState2 = true">
                            短信记录
                          </div>
                          <div class="test-button1 test_button2" style="width: auto;" @click="showchangetestphone = true">
                            修改测试手机号
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="xiao-hug xiao_hug" style="position: absolute; left: 690px; top: 80px">
                      <div style="margin: 0 auto; width: 256px">
                        <div class="mobile-box">
                          <div class="message-content">【{{ selSuffixName }}】{{ postForm.content | enVToChinese }}{{ TTip }}</div>
                        </div>
                        <div class="mobile-tips">短信预览效果</div>
                      </div>
                    </div>
                  </div>

                  <div class="btn_all" style>
                    <div class="button3" style="float: left" @click="backOne">
                      返回上一步
                    </div>
                    <template v-if="menuType != 9">
                      <el-button
                        class="button2"
                        style="float: right"
                        @click="
                          () => {
                            return saveTap(1);
                          }
                        "
                        :class="{ disBtn2: disBtn2 === true }"
                      >
                        <i v-show="loadBtn1" class="el-icon-loading"></i>
                        保存并开启</el-button
                      >
                    </template>
                    <el-button class="button1" style="float: right" @click="saveTap(0)" :class="{ disBtn1: disBtn1 === true }">
                      <i v-show="loadBtn2" class="el-icon-loading"></i>
                      保存设置</el-button
                    >
                  </div>

                  <!-- </div> -->
                </div>
              </el-drawer>
            </div>
          </div>
          <!-- <div :style="{'height':scorllY}"></div> -->
          <!--<div style="height: 1px;"></div>-->
        </div>
      </div>
    </el-drawer>

    <!-- 自定义城市弹窗 -->
    <city-popover v-model="areaState" :checkedList="checkedList" :isProvince="true" @on-change="checkedCity"></city-popover>
    <!-- 选择商品组件 -->
    <!-- <select-goods v-if="goodsState" @transferName="goodsPopupBtn" :postForm="postForm.itemList"></select-goods> -->
    <!-- //预售尾款，好评中差评（自营）sku维度商品查询 -->
    <select-goods
      v-if="goodsState"
      :isShow="goodsState"
      :moduleType="true"
      :selectGoods="returnSelectGoodsAppoint"
      :selectGoodsSkuList="selectGoodsSkuList"
      :GoodsSkuIsflay="GoodsSkuIsflay"
      @close="selectGoodsChange1"
    ></select-goods>

    <select-goods
      v-if="goodsState2"
      :isShow="goodsState2"
      :moduleType="true"
      :selectGoods="returnSelectGoodsExclude"
      :selectGoodsSkuList="selectGoodsSkuExclude"
      :GoodsSkuIsflay="GoodsSkuIsflay"
      @close="selectGoodsChange2"
    ></select-goods>

    <!-- 商品复购 -->
    <select-goods
      v-if="goodsState3"
      :isShow="goodsState3"
      :moduleType="true"
      :skuSearch="true"
      :selectGoodsSkuList="returnSelectGoodsAppoint"
      @close="selectGoodsChange"
    ></select-goods>

    <!-- 短信模板 -->
    <sms-template
      v-if="templateShow"
      :isShow="templateShow"
      v-bind="$attrs"
      :isOfficial="isOfficial"
      :iscareModul="true"
      @close="templateChange"
    ></sms-template>

    <!-- 保存模板 -->
    <my-popup title="保存模板" zIndex="3330" width="370" :flag="keepTmpShow" @close="keepTmpChange">
      <div class="selectBox">
        <div class="headCnt">
          <span>选择栏目：</span>
          <el-select v-model="keepTmpValue" placeholder="请选择" style="width: 240px">
            <el-option v-for="(item, index) in dirList" :key="index" :label="item.title" :value="item.tid"></el-option>
            <!-- <el-option label="云短信旗舰店专用" :value="1"></el-option>
            <el-option label="太阳短信旗舰店专用" :value="2"></el-option>
            <el-option label="月亮短信旗舰店专用" :value="3"></el-option>-->
          </el-select>
        </div>
        <button class="keepBtn" @click="keepTmpChange(1)">保存模板</button>
      </div>
    </my-popup>

    <!-- 短信记录 -->
    <sms-template2 :smsDialog="smsState2" v-if="smsState2" @transferName="shortBtnTwo2"></sms-template2>
    <!-- 插入短链接 -->
    <!-- <insert-coupon-url
      v-if="insertShortUrlShow"
      @close="insertUrlChange"
    ></insert-coupon-url> -->
    <!-- 插入短链接 -->
    <insert-short-dialog v-show="insertShortUrlShow" zIndex="4000" :typeSms="2" @close="handleCloseShort"></insert-short-dialog>

    <!-- <insert-short-dialog v-if="insertShortUrlShow" :typeSms="3" zIndex="4000" @close="insertUrlChange"></insert-short-dialog> -->

    <!-- 发送确认弹窗 -->
    <el-dialog :visible.sync="showSendConfirm" title="发送确认" append-to-body width="450px" custom-class="send-con-dialog">
      <div>
        <span>提交号码为 {{ phoneLenght }}</span>
        <!-- <span v-if="!isTestSend">发送人数<span :style="{'color': globalBG}">{{sendPeopleNum}}</span>人</span> -->
        ，当前短信字数为
        <span :style="{ color: changeColor }">{{ sendInfoLength }}</span>
        字，每条短信以
        <span :style="{ color: changeColor }">{{ Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70) }}</span>
        条计费，提交
        <span :style="{ color: changeColor }">{{ phoneLenght * Math.ceil(sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70) }}</span>
        条短信，以实际发送条数为准！
      </div>
      <div class="btn-group">
        <el-button type="primary" @click="handleSendConfirm">发送</el-button>
        <el-button @click="showSendConfirm = false">取消</el-button>
      </div>
    </el-dialog>
    
    <changetestphone :textPhoneId="textPhoneId" :nowtestMobiles="nowtestMobiles" v-if="showchangetestphone" @close="showchangetestphone = false" @mobilPhoneSubmit="mobilPhoneSubmit"></changetestphone>
  </div>
</template>

<script>
import shortMessage from "./chidrenCare/shorts-message.vue";
// import selectBaby from "./chidrenCare/goods-abbreviation.vue";
import logisticsLink from "./chidrenCare/logisticsLink";

import sendConfirm from "@/components/send-confirm.vue";
import insertCouponUrl from "@/views/serviceCenter/components/insert-short-url";
import CityPopover from "@/components/city-popover-x";
// import SelectGoods from "../../components/select-goods";
import SelectGoods from "@/components/selectGoodsMonitor";
import myPopup from "@/components/myPopup";
import smsTemplate from "@/views/serviceCenter/sms_template";
import smsTemplate2 from "@/components/sms-templates-x.vue";

import { getTemplateDir, createTemplate } from "@/api/smsTemplates";
import { getInfo, updateActivityCodeConfig, addActivity, deleteActivity, activitySwitch, importActivityCode } from "@/api/activity";
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { addOrdersCare, updateOrdersCare, getItemBuyerRebuyAvg } from "@/api/care/orderCare";
import { getSmsSensitiveWordList, detectionSmsKeyword } from "@/api/public";
import { preCommit,NewPreCommit, precisionMarketing, platformSend,getValidSmsTestMobiles } from "@/api/smsSend";
import { mapState, mapMutations, mapActions } from "vuex";
import insertShortDialog from "@/components/insert-short-dialog";
import changetestphone from "@/components/changetestphone.vue";
// import { SEND_DEFAULT_INFO } from "./carePublic";
import moment from "moment";
import { fips } from "crypto";
// import miniPage from "../service/dialog/miniPage";

const defaultForm = {};
// const JZH_CODE = "9,10,11";
const JZH_CODE = [
  { code: "9", city: "" },
  { code: "10", city: "" },
  { code: "11", city: "" },
];
// const PY_CODE = "5,25,26,29,31";
const PY_CODE = [
  { code: "5", city: "" },
  { code: "25", city: "" },
  { code: "26", city: "" },
  { code: "29", city: "" },
  { code: "31", city: "" },
];

const promixify = (api) => {
  return (options, ...params) => {
    return new Promise((resolve, reject) => {
      api(Object.assign({}, options, { success: resolve, fail: reject }), ...params);
    });
  };
};
const getItemBuyerRebuyAvgNew = promixify(getItemBuyerRebuyAvg);

const DEFAULT_TIME = {
  1: { day: "3", hour: "9", type: "0" },
  2: { time: "30", type: "0" },
  3: { time: "30", type: "0" },
  4: { day: "30", hour: "9" },
  5: { hour: "9", type: "2" },
  6: { hour: "9", type: "2" },
  7: { hour: "9", type: "2" },
  8: { day: "30", hour: "9" },
  9: { day: "30", hour: "9" },
};
export default {
  name: "page-condition",

  destroyed() {
    document.body.style.overflow = "";
  },
  watch: {},
  components: {
    shortMessage,
    smsTemplate,
    smsTemplate2,
    sendConfirm,
    // couponLink,
    CityPopover,
    SelectGoods,
    // selectBaby,
    logisticsLink,
    insertCouponUrl,
    insertShortDialog,
    myPopup,
    changetestphone
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    isShowTip: {
      type: Boolean,
      default: false,
    },
    scorllY: {
      type: String,
      require: true,
    },
    bodyHeight: {
      type: Number,
      require: true,
    },
    isAdd: {
      type: Boolean,
    },
    menuType: {
      type: Number,
    },
    menuData: {
      type: Object,
    },
    // 接受父组件的数据
    postForms: {
      type: Object,
      // default() {
      //   return defaultForm;
      // }
    },
    isShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      textPhoneId:"",
      nowtestMobiles:"",
      showchangetestphone:false,
      testOptions: [], // 获取测试手机号
      Selectmobiles:[],

      actIcon: false,
      longlinkFlay: false,
      longUrllink: "",
      GoodsSkuIsflay: false,
      selectGoodsSkuExclude: [],
      selectGoodsSkuList: [],
      // drawerWidth: '780px',
      drawerWidth: "1000px",
      drawers: false,
      innerDrawer: false, // 嵌套的抽屉
      timer: null,
      tableList: [],
      TTip: "",
      returnSelectGoods: [],
      returnSelectGoodsAppoint: [], //选择商品回显
      returnSelectGoodsExclude: [], //选择商品回显
      taskId: "",
      // activityCodeNum:0,    //活动码个数
      // 插入短链接状态控制 ----- 内容
      insertShortUrlShow: false,
      loadBtn1: false,
      loadBtn2: false,
      isShowSelectGoods: false,
      startList: [
        {
          value: "1",
          label: "1星",
        },
        {
          value: "2",
          label: "2星",
        },
        {
          value: "3",
          label: "3星",
        },
        {
          value: "4",
          label: "4星",
        },
        {
          value: "5",
          label: "5星",
        },
      ],
      moneyTypeList: [
        {
          value: "0",
          label: "不限",
        },
        {
          value: "1",
          label: "在线支付",
        },
        {
          value: "2",
          label: "货到付款",
        },
      ],
      payTypeList: [
        {
          value: "1",
          label: "货到付款",
        },
        {
          value: "2",
          label: "邮局汇款",
        },
        {
          value: "3",
          label: "自提",
        },
        {
          value: "4",
          label: "在线支付",
        },
        {
          value: "5",
          label: "公司转账",
        },
        {
          value: "6",
          label: "银行卡转账",
        },
      ],
      templateShow: false, // 短信模板弹窗
      stepNum: 1, // 步骤条
      disBtn1: "",
      disBtn2: "",
      hahah: "",
      remindConfigItemObj: {},
      goodsOderState: false,
      difficultType: 1,
      testVueDialog: false,
      babyState: false, //宝贝
      logisticsLinkDialog: false, //物流
      lastInsertLink: "",
      checkedList: [],
      maxStartRemindTime: "00:00:00",
      filterWordsList: [],
      getInputFilterList: [],
      cursurPosition: 0, //光标内容
      suffixList: [], //短信签名列表
      selSuffixName: "【服务市场测试店铺】", //选中签名
      tradeFromJHS: "JHS",
      //sendInfoLength: "", //输入长度
      areaList: [],
      taskTile: "",
      postForm: {
        orderStartTime: "",
        testSelect: 0,
        warePeriodType: "",
        dayLimit:''
      },
      checkedTradeFrom: [],
      reasonReturnList: [], //退款原因列表
      buyerGoodsValue: "0",
      checkedMemberLevel: [],
      checkedSellerFlag: [],
      checkedFilterCondition: [],
      SellerRemarkTips: false,
      allRadio: false,
      goodsState: false,
      goodsState2: false,
      goodsState3: false,
      isOne: true,
      isTwo: false,
      dialogVisible: true,
      isNoteReply: false,
      //changeColor: "#2062E7",
      topPX: "146px",
      name: "",
      radioTime: "1",
      taskTime: [],
      sendTime: "",
      testOptions: [
        {
          value: "0",
          label: "手动输入",
        },
        {
          value: "1",
          label: "13143364647",
        },
        {
          value: "2",
          label: "13143364648,15578842725,15578842424",
        },
      ],
      sendOptions: [
        {
          value: "1",
          label: "发送",
        },
        {
          value: "0",
          label: "不发送",
        },
      ],
      options: [
        {
          value: "-1",
          label: "前",
        },
        {
          value: "0",
          label: "当天",
        },
        {
          value: "1",
          label: "后",
        },
      ],
      optionsMouth: [
        {
          value: "1",
          label: "距离上次下单",
        },
        {
          value: "2",
          label: "距离第一次下单",
        },
        // {
        //   value: "3",
        //   label: "距离上次交易完成",
        // },
        // {
        //   value: "4",
        //   label: "距离第一次交易完成",
        // },
      ],
      value: "",
      optionsTwo: [
        {
          value: "1",
          label: "不发送",
        },
        {
          value: "2",
          label: "顺延第二天发送",
        },
      ],
      valueTwo: "",
      optionsThree: [
        {
          value: "",
          label: "全部",
        },
        // {
        //   value: "0",
        //   label: "未付定金"
        // },
        {
          value: "1",
          label: "已付定金，未付尾款",
        },
        {
          value: "2",
          label: "已付定金，已付尾款",
        },
      ],
      valueThree: "",
      sendTimeStart: "",
      sendTimeEnd: "",
      sendTimeTwo: "",
      sendTimeStartTwo: "",
      sendTimeEndTwo: "",
      checked1: false,
      checked2: false,
      checked3: false,
      checked4: false,
      cheakenInputOne: "",
      cheakenInputTwo: "",
      cheakenInputThree: "",
      cheakenInputFour: "",
      sendRadio: "1",
      sendRadioTwo: "1",

      isIndeterminate: true,
      radioTypeOne: "1",
      flagOne: [1],
      isIndeterminateTwo: true,
      filterOne: [1],
      filterData: [
        {
          value: 1,
          name: "首次到店会员",
          input: true,
        },
        {
          value: 2,
          name: "首次到店会员",
          input: true,
        },
        {
          value: 3,
          name: "店铺会员",
          input: false,
        },
        {
          value: 4,
          name: "高级会员",
          input: false,
        },
        {
          value: 5,
          name: "VIP会员",
          input: false,
        },
        {
          value: 6,
          name: "至尊VIP会员",
          input: false,
        },
      ],
      filter1: false,
      filter2: false,
      filter3: false,
      filter4: false,
      filter5: false,
      filterInput: "",
      filterInput2: "",
      areaOne: 1,
      areaData: [
        {
          value: "0",
          name: "全部",
        },
        {
          value: "1",
          name: "江浙沪",
        },
        {
          value: "2",
          name: "偏远地区（疆藏云海）",
        },
        {
          value: "3",
          name: "自定义",
        },
      ],
      shoppingOne: 1,
      shoppingData: [
        {
          value: "0",
          name: "全部商品",
        },
        {
          value: "1",
          name: "指定商品",
        },
        {
          value: "2",
          name: "排除商品",
        },
      ],
      allArea: false,
      smallArea: false,
      farArea: false,
      isEast: true,
      eastAll: false,
      checkedElse: false,
      areaState: false,
      areaStateLength: 0,
      goodsStateLength: 0,
      goodsStateLength1: 0,
      goodsStateLength2: 0,
      radio: "1",
      textarea: "",
      shortState: false,
      smsState: false, //模板对话框
      smsState2: false,
      sendState: false,
      couponState: false,
      imgDisplay: "none",
      sendInfoList: [
        {
          id: "1",
          label: "#买家姓名#",
        },
        {
          id: "2",
          label: "#买家昵称#",
        },
        {
          id: "3",
          label: "#订单号#",
        },
        {
          id: "4",
          label: "#下单时间#",
        },
        {
          id: "5",
          label: "#商品名称#",
        },
      ],
      /***
       * sms测试发送
       * */
      smsTestSendParams: {
        mobiles: "",
      },
      phoneLenght: 0, //测试号码数量
      showSendConfirm: false, //是否显示发送确认弹框
      selectLoading: false, // 点选择商品弹窗时，弹窗还没显示的loading
      pickerDisabled: this.beginDate(), // 限制结束时间要大于开始时间
      dirList: [],
      keepTmpShow: false, // 保存模板状态控制 ---- 内容
      keepTmpValue: "",
      originIds: [],
      memberLevelOptions: [
        {
          value: "-1",
          name: "全部",
        },
        {
          value: "1",
          name: "一星会员",
        },
        {
          value: "2",
          name: "二星会员",
        },
        {
          value: "3",
          name: "三星会员",
        },
        {
          value: "4",
          name: "四星会员",
        },
        {
          value: "5",
          name: "五星会员",
        },
      ],
    };
  },
  beforeCreate: function() {},
  filters: {
    getCityLength(list) {
      var length = 0;
      if (list && list.length > 0) {
        list.forEach((item) => {
          if (item.city) {
            length += item.city.split(",").length;
          }
        });
      }
      return length;
    },
  },
  created: function() {
    console.log("menuType===", this.menuType);
    console.log("this.isAdd", this.isAdd);
    document.body.style.overflow = "hidden";
    // console.log(this.scorllY);
    this.getOfficialSuffix();

    if (!this.isAdd) {
      this.postForm = this.postForms;
      console.log(this.postForms);
      this.postForm.isFilterFreeGoods = this.postForms.isFilterFreeGoods;
      this.$forceUpdate();
      console.log("isFilterFreeGoods22222222",this.postForm.isFilterFreeGoods);
      
      // const lodingPage = this.postForms.content.indexOf("#LandingPage#") > -1;
      const lodingPage = this.postForms.transformUrl;
      this.longlinkFlay = lodingPage;
      this.longUrllink = lodingPage ? this.postForms.url : "";
      // this.postForm = this.postForms;
      this.postForm = Object.assign({}, this.postForms);
      this.postForm.content = lodingPage
        ? this.postForms.content.replace("#LandingPage#", ` ${this.postForms.transformUrl} `)
        : this.postForms.content;

      if (this.postForm.warePeriodType == "2") {
        this.postForm.wareConsumeType = "";
        // this.postForm.sendConditionHour2 = this.postForm.sendConditionHour;
        // this.postForm.sendConditionHour = '';
      }

      // 任务已选商品回显
      //  console.log(this.postForm.itemList);
      var originIds = [];
      if (this.postForm.itemList.wareList.length || this.postForm.itemList.skuList) {
        // this.returnSelectGoods = this.postForm.itemList.map((i) => {
        //   originIds.push(i.wareId);
        //   return {
        //     ...i,
        //     wareId: Number(i.wareId),
        //     jdPrice: i.jdPrice || i.jdPrices,
        //     wareTitle: i.itemTitle || i.wareTitle || i.title,
        //     logo: i.images || i.logo,
        //   };
        // });
        this.returnSelectGoods = this.postForm.itemList.wareList.map((i) => {
          originIds.push(i.wareId);
          return {
            ...i,
            wareTitle: i.itemTitle || i.title,
            logo: i.images || i.logo,
            isAdd: true,
            wareId: Number(i.wareId),
            skuId: i.skuId ? i.skuId : "",
            skuList: i.skuId
              ? i.skuId.split(",").map((ele) => {
                  return { skuId: ele };
                })
              : [],
          };
        });
        let selectGoodsSkuList = this.postForm.itemList.skuList.map((i) => {
          return {
            ...i,
            wareTitle: i.itemTitle || i.title,
            logo: i.images || i.logo,
            isAdd: true,
            // wareId: Number(i.wareId),
            skuId: i.skuId,
          };
        });
        this.originIds = originIds;
        this.goodsStateLength = this.postForm.itemList.skuList ? this.postForm.itemList.skuList.length : 0;
        if (!this.venderType) {
          let skuArr = this.postForm.itemList.wareList
            .map((i) => i.skuId)
            .join(",")
            .split(",");
          let skuArr1 = this.postForm.itemList.skuList.map((i) => i.skuId);
          this.goodsStateLength = this.unique(skuArr1, skuArr).length;
        }
        if ((this, this.postForms.isAllItem == 1)) {
          this.returnSelectGoodsAppoint = this.returnSelectGoods;
          this.goodsStateLength1 = this.goodsStateLength;
          this.selectGoodsSkuList = selectGoodsSkuList;
        } else {
          this.returnSelectGoodsExclude = this.returnSelectGoods;
          this.goodsStateLength2 = this.goodsStateLength;
          this.selectGoodsSkuExclude = selectGoodsSkuList;
        }
        // this.isShowSelectGoods = true
        if (this.taskTypeActive == 25) {
          this.returnSelectGoodsAppoint = this.postForm.itemList.skuList;
          this.tableList = this.postForm.itemList.skuList.map((i) => {
            return {
              wareTitle: i.title,
              price: i.jdPrice,
              wareLogo: i.logo,
              skuId: i.skuId,
              wareId: i.wareId,
              isEdit: false,
              periodDay: i.periodDay,
              defaultPeriodDay: i.defaultPeriodDay,
            };
          });
        }
      }
      // if(this.postForm.isLimitSend){
      //   this.postForm.limitSendNum = true;
      //   this.postForm.sendNum = this.postForm.limitSendNum
      // }
      if (this.postForm.isAllItem != 0) {
        this.isShowSelectGoods = true;
      }
      // 地区选择回显
      this.checkedList = this.postForm.zip;
      // if (this.postForm.zip && this.postForm.zip.join(",") == JZH_CODE) {
      //   this.postForm.areaType = "1";
      // }
      // if (this.postForm.zip && this.postForm.zip.join(",") == PY_CODE) {
      //   this.postForm.areaType = "2";
      // }
    }
    // 创建新任务初始化
    if (this.isAdd) {
      console.log(this.$parent.tittle);
      this.longlinkFlay = false;
      this.longUrllink = "";
      this.postForm = {
        taskName: this.menuType == 9 ? "" : this.$parent.tittle + " " + this.getNowDate(), //任务名称
        taskType: 0, //持续开启 (0:持续开启，1指定时间)
        warePeriodType: 1, // (0:回购型，1:推荐型)
        sendOpportunity: 1, //发送时间  首购有礼(1:付款时发送，2:订单完成时发送)
        taskStartTime: "", //指定任务时间开始
        taskEndTime: "", //指定任务时间结束
        moneyPayStartTime: "", //订金支付时间开始
        moneyPayEndTime: "", //订金支付时间结束
        payType: [], // 付款方式
        moneyType: "0", // 付款类型
        selectStart: [], // 针对评分
        sendCondition2: "30", //发送时间
        activitySendTimeType: "", //活动码模块发送时间
        // sendUnitTime2: DEFAULT_TIME[this.menuType].type, //发送时间单位(0 分， 1 时， 2 天)

        sendUnitTime3: "1", //满月礼、百日礼、周年庆发送时间类型(1 ， 2 ， 3  ,4)
        sendDays: "30",
        sendTime: "9",
        activityCodeNum: 0, //活动码个数

        sendUnitTime3: "1", //满月礼、百日礼、周年庆发送时间类型(1 ， 2 ， 3  4)
        activityCodeNum: 0, //活动码个数

        // 回购型
        wareConsumeType: "0", //商品消耗时段
        sendConditionDay: 3, //回购型商品消耗发送时间:天
        sendConditionHour: 9, //发送时间:时
        // sendConditionHour2: '',

        startRemindTime: "07:00", //发送时段开始
        endRemindTime: "22:00", //发送时段结束
        remindSendType: "1", //发送时段，其他时间，发送类型1， 超出时间不发送， 2、 超出时间次日发送 默认1
        // sendTime: "", //发送时段，其他时间设置多久发送
        isLunchBreak: false, // 发送时段 是否开启午休时间 1 开启(true)， 0 关闭(false)
        startLunchBreak: "12:00", //发送时段，午休开始时间
        endLunchBreak: "13:00", //发送时段，午休结束时间
        isOrderMoney: false, //发送条件 是否开启实付金额 1 开启(true) 0 关闭(false),
        startOrderMoney: "", //发送条件 实付金额开始,
        endOrderMoney: "", //发送条件 实付金额结束,
        dealCount: false, //发送条件 交易次数,
        startBuyTotalCount: "", //发送条件 交易次数开始,
        endBuyTotalCount: "", //发送条件 交易次数结束,
        isProductNum: false, //发送条件 是否开启商品数量 1 开启(true) 0 关闭(false),
        startProductNum: "", // 发送条件 商品数量开始,
        endProductNum: "", // 发送条件 商品数量结束,
        isBuyerMessage: false, // 发送条件 是否开启买家留言包含 1 开启(true) 0 关闭(false),
        buyerMessage: "", //发送条件 买家留言包含,
        isBuyerMessageSend: "1", //发送条件 买家留言是否发送 1 发送， 0 不发送,
        isDefaultGoodRate: false,
        isSellerRemark: false, // 发送条件 是否开启卖家备注包含 1 开启(true) 0 关闭(false),
        sellerRemark: "", // 发送条件 卖家备注包含,
        isSellerRemarkSend: "1", //发送条件 卖家备注是否发送 1 发送， 0 不发送,
        isFilterFreeGoods: false, // 是否过滤赠送商品 
        logisticsNum: "",

        tradeFrom: [""], //订单来源 WAP(手机);TAOBAO(PC端);JHS(聚划算);HITAO(嗨淘);TOP(TOP平台) 一笔订单可能同时有以上多个标记， 则以逗号分隔,
        shipmentNum: "0", //运单号  0 全部发送   1 不发送有运单号订单  2 不发送无运单号订单
        memberSelect:'0' , // 会员筛选  0全部  1只发送会员   2只发送非会员
        memberSelectLevel: ["-1"], // 会员等级列表
        RemindLevel: [], //提醒等级
        orderType: "0", //订单类型 0 不限， 1 预售， 2 非预售 传入数值,
        presellType: "", //订单类型 预售类型 全部'' 0 未付定金， 1 已付定金未付尾款， 2 定金已付尾款已付 传入数值,
        sellerFlag: [""], //订单标旗 卖家备注旗帜 灰、 红、 黄、 绿、 蓝、 紫 分别对应 0、 1、 2、 3、 4、 5 传入数值,不限传'',
        precedenceMobileType: "1", //发送号码 1、 优先收货人手机号码， 2、 优先支付宝手机号码, 3、 收货人手机号码 4、 支付宝手机号码 默认1,
        memberLevel: [""], // 会员等级 0 店铺会员 1 普通会员， 2 高级会员， 3 VIP会员， 4 至尊VIP 多个逗号拼接,不限传''
        filterCondition: ["1"], //过滤设置  0: 同一个手机多少天只提醒一次， 1: 屏蔽黑名单， 2 屏蔽给过中差评客户， 3 屏蔽退过款的客户 5. 同一买家有付过款的不催前后 6. 评价内容含指定屏蔽词不发 7. 屏蔽无需物流的订单 8. 评价字数超过多少不发,
        filterWantTime: "0", //过滤设置 同一个旺旺设置天数,
        filterMobileTime: "0", //过滤设置 同一个手机设置天数,
        areaType: "0", //选择地区 选择地区 0 全部地区， 1 江浙沪， 2 偏远地区， 3 指定地区,
        zip: "", // 选择地区 地区编码
        isAllItem: "0", //选择商品 选择商品 0 全部商品， 1 指定商品， 2 排除商品 默认0,
        itemList: [], // 选择商品 商品集合,
        suffix: "【好听的面】", // 短信签名 带上[],
        content: "", // 短信内容,
        isOpen: 1, // 是否开启 1 开启， 0 关闭 默认1,
        type: this.menuType || 1, // 类型 类型 必传 1 下单关怀 2 下单关怀(货到) 3 处方药关怀 4 常规催付 5 二次催付 6 预售催付 7 聚划算催付 8 付款关怀 9 智能凑单 10 延时发货 11 发货提醒 12 疑难件提醒 13 同城提醒 14 派件提醒 15 签收提醒 16 物流广告 17 回款关怀 18 自动催评 19 好评感谢 20 中差评安抚 21 申请退款 22 同意退款 23 拒绝退款 24 退款成功
        //后续的条件
        addOnItems: "", //选择商品 3: 凑单商品,
        filterBeyondWords: "", //过滤设置 设置评价超过字数,
        filterBlockWord: "", //过滤设置 设置屏蔽过滤词,
        filterBuyerTime: "", //过滤设置 同一个卖家付过款设置天数,
        participationNumber: "", //参与次数限制
        goodDays: "", //发送条件 好评天数,
        goodNumber: "", // 发送条件 好评字数超过多少字,
        isGoodDays: false, // 发送条件 是否开启确认收货后多少天内给好评 1 开启 0 关闭,
        evaluateWhetherToSend: false, // 已评价是否发送短信 0不发送 1发送 ,
        isGoodNumber: "", // 发送条件 是否开启好评字数 1 开启 0 关闭,
        isNoteReply: false, //是否短信回复备注到卖家备注 0 是 1 否,
        notUpdatedTime: "24", // 物流未更新疑难件规则 设置包裹未更新时间,
        notUpdatedUnit: "1", //物流未更新疑难件规则 设置包裹未更新时间单位,
        orderSplitCondition: false, // 拆分订单限制发送条件, 1、 同一订单拆单发货发1条短信， 2、 同一订单拆单发货发多条短信,
        orderSplitType: "1", //拆分订单类型, 1、 不限， 2、 仅限拆单， 3、 排除拆单,
        paymentType: "0", // 催付类型0催定金 订金未付开始发送 1 催尾款 定金已付尾款未付开始发送,
        orderStartTime: "",
        precedenceLevel: "", // 优先级别,
        reasonReturn: [], //退货原因 传入原因ID 多个以半角逗号分隔,
        reasonReturnType: "", //退货原因 是否排除退货原因 0: 全选 1: 排除,
        // refundApply: this.menuType == 21 ? "0" : "", //发送时间 退款申请 0: 退款 1: 退款退货 2: 退款不退货,
        remindConfigItem: [], // 选择商品 凑单商品,
        remindSellerConfigId: "", //id,
        // rxAuditStatus: this.menuType == 3 ? "1" : "", //发送时间 处方药（ 处方药审核状态， 1 审核通过 - 1 审核不通过 只有开启处方药提醒才有改字段）,
        sellerNick: "", // 买家昵称,
        unReceiptedZip: "", // 疑难件提醒 未签收地区编码,
        unUpdateZip: "", //疑难件提醒 未更新地区编码,
        unreceiptedTime: "3", // 未签收疑难件规则 设置包裹未签收时间,
        unreceiptedUnit: "2", // 未签收疑难件规则 设置包裹未签收时间单位,
        shipmentsRemindType: "0",
        // limitSendNum:false,
        // sendNum:'',
      };

      //新建任务 默认短信消息
      // this.inputContent = SEND_DEFAULT_INFO[this.menuType];

      // 双十一作战攻略跳转过来的
      if (localStorage.getItem("myMessageTheme") && localStorage.getItem("myMessageTheme").length > 0) {
        this.postForm.taskName = localStorage.getItem("myMessageTheme");
        // 任务时间（指定时间）
        if (localStorage.getItem("myStartTime") && localStorage.getItem("myStartTime").length > 0) {
          this.postForm.taskType = 1;
          this.taskTimeChange = [localStorage.getItem("myStartTime"), localStorage.getItem("myEndTime")];
        }
        // postForm.sendUnitTime
        if (localStorage.getItem("myStartRemindTime") && localStorage.getItem("myStartRemindTime").length > 0) {
          // this.postForm.startRemindTime = localStorage.getItem("myStartRemindTime"); // 发送时段，开始
          // this.postForm.endRemindTime = localStorage.getItem("myEndRemindTime"); // 发送时段，结束
          this.$set(this.postForm, "startRemindTime", new Date(2019, 7, 4, 0, 5));
          this.$set(this.postForm, "endRemindTime", new Date(2019, 7, 4, 23, 59));
          // console.log("startRemindTime,endRemindTime===",this.postForm.startRemindTime,this.postForm.endRemindTime);
        }
        // 发送时间
        if (localStorage.getItem("mySendTime") && localStorage.getItem("mySendTime").length > 0) {
          this.postForm.sendCondition = localStorage.getItem("mySendTime");
        }
        // 发送时间的类型（0分钟，1小时）
        if (localStorage.getItem("mySendTimeType") && localStorage.getItem("mySendTimeType").length > 0) {
          this.postForm.sendUnitTime = localStorage.getItem("mySendTimeType");
        }
        // 催付类型:
        if (localStorage.getItem("myPaymentType") && localStorage.getItem("myPaymentType").length > 0) {
          this.postForm.paymentType = localStorage.getItem("myPaymentType");
        }
        // 短信内容
        if (localStorage.getItem("myMessageContent") && localStorage.getItem("myMessageContent").length > 0) {
          this.inputContent = localStorage.getItem("myMessageContent");
          console.log("111111111", this.inputContent, localStorage.getItem("myMessageContent"));
        }
        localStorage.setItem("myMessageTheme", "");
      }

      if (this.SellerSignData && this.SellerSignData[0].suffix) {
        this.selSuffixName = this.SellerSignData[0].suffix; //默认第一个签名
        this.postForm.suffix = this.SellerSignData[0].suffix;
      }

      //  this.postForm=addForm
      //新建任务默认勾选
    }
    // console.log(this.postForm);
    // return

    this.isNoteReply = this.postForm.isNoteReply == "0" ? true : false;

    this.taskTile = "下单关怀" + moment().format("YYYYMMDD HH:mm");
    if (this.taskTimeChange[0] == "" || !this.taskTimeChange || this.taskTimeChange[0] == "0") {
      const date = [this.getCurrentMonthFirst() + " 00:00:00", this.msToDate(this.getCurrentMonthLast()).hasTime];
      this.postForm.taskStartTime = date[0];
      this.postForm.taskEndTime = date[1];
    }
    const date1 = [this.getDay(0, "-") + " 07:00:00", this.getDay(0, "-") + " 22:00:00"];
    this.startRemindTime = date1[0];
    this.endRemindTime = date1[1];
  },
  computed: {
    // 获取vuex中是state.SellerSignData和state.modelName的值
    ...mapState(["SellerSignData", "modelName"]),
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    smsLabel() {
      return this.$route.meta.smsLabel;
    },
    taskTypeActive() {
      return this.$route.meta.taskType;
    },
    isOfficial() {
      return this.$route.meta.isOfficial;
    },
    ...mapState({
      changeColor: "globalBG",
      globalLableList: "globalLableList",
      //   把city映射给currentCIty
    }),
    taskTimeChange: {
      get: function() {
        let taskTime = [];
        taskTime.push(this.postForm.taskStartTime);
        taskTime.push(this.postForm.taskEndTime);
        return taskTime;
      },
      set: function(value) {
        if (value !== null) {
          this.taskTime = value;
          this.postForm.taskStartTime = value[0];
          this.postForm.taskEndTime = value[1];
        } else {
          const date = [this.getCurrentMonthFirst() + " 00:00:00", this.msToDate(this.getCurrentMonthLast()).hasTime];
          this.postForm.taskStartTime = date[0];
          this.postForm.taskEndTime = date[1];
          // this.postForm.taskStartTime = ''
          // this.postForm.taskEndTime = ''
        }
      },
    },
    tradeFromChange: {
      get: function() {
        if (this.isNullStr(this.postForm.tradeFrom)) {
          return this.checkedTradeFrom;
        }
        return this.postForm.tradeFrom.split(",");
      },
      set: function(value) {
        this.checkedTradeFrom = value;
        this.postForm.tradeFrom = value.join(",");
      },
    },
    memberLevelChange: {
      get: function() {
        if (this.isNullStr(this.postForm.memberLevel)) {
          return this.checkedMemberLevel;
        }
        return this.postForm.memberLevel.split(",");
      },
      set: function(value) {
        this.checkedMemberLevel = value;
        this.postForm.memberLevel = value.join(",");
      },
    },
    sellerFlagChange: {
      get: function() {
        if (this.isNullStr(this.postForm.sellerFlag)) {
          return this.checkedSellerFlag;
        }
        return this.postForm.sellerFlag.split(",");
      },
      set: function(value) {
        this.checkedSellerFlag = value;
        this.postForm.sellerFlag = value.join(",");
      },
    },
    filterConditionChange: {
      get: function() {
        if (this.isNullStr(this.postForm.filterCondition)) {
          return this.checkedFilterCondition;
        }
        return this.postForm.filterCondition.split(",");
      },
      set: function(value) {
        this.checkedFilterCondition = value;
        this.postForm.filterCondition = value.join(",");
      },
    },
    inputContent: {
      get() {
        return this.postForm.content;
      },
      set(val) {
        this.postForm.content = val;
      },
    },
    contentLength() {
      return this.postForm.content.length;
    },
    sendInfoLength() {
      try {
        if (this.postForm.content) {
          return this.$ChineseVToEn(this.postForm.content, true).length + this.selSuffixName.length + 2;
        } else {
          return this.selSuffixName.length + 2;
        }
      } catch (e) {
        return 0;
      }
    },
    // 针对评分
    handleStarList: {
      get() {
        if (this.menuType == 14) {
          this.postForm.selectStart = this.startList.slice(3).map((item) => item.value);
          return this.startList.slice(3);
        } else {
          this.postForm.selectStart = this.startList.slice(0, 3).map((item) => item.value);
          return this.startList.slice(0, 3);
        }
      },
    },
  },
  mounted() {
    this.getValidSmsTestMobiles()
    if (this.postForms == undefined) {
      this.$set(this.postForm, "filterCreatedStart", this.getDateStr(-30) + " 00:00:00");
      this.$set(this.postForm, "filterCreatedEnd", this.getDateStr(-1) + " 23:59:59");
    }

    // 抽屉从右出现
    this.drawers = this.drawer;

    // 订金支付时间
    // this.postForm.moneyPayStartTime = this.getCurrentMonthFirst() + " 00:00:00";
    // this.postForm.moneyPayEndTime = this.msToDate(this.getCurrentMonthLast()).hasTime;
  },
  watch: {
    goodsState(val) {
      if (val === true) {
        this.selectLoading = false;
      }
    },
  },
  methods: {
    mobilPhoneSubmit(val){
      this.getValidSmsTestMobiles()
      this.showchangetestphone = false
    },
    getValidSmsTestMobiles() {
      // 获取测试手机号
      getValidSmsTestMobiles().then(res => {
        if (res.code == 1) {
          this.Selectmobiles = [];
          this.testOptions = res.data.smsTestMobiles
          this.nowtestMobiles = res.data.smsTestMobiles.join(',')
          this.textPhoneId = res.data.id
        }
      })
    },
    // 短信测试手机号 
    selectTestMobiles(val) {
      this.smsTestSendParams.mobiles = this.Selectmobiles.join(',')
    },
    limitInput1(event){
     var reg = /^([1-9][0-9]*)$/;
     if (reg.test(event.target.value)) { //只能输入大于0的正整数
      this.postForm.dayLimit= event.target.value
     } else {
      this.postForm.dayLimit= ''
      this.$message.error('只能输入大于0的正整数')
     }
    },
    smsContent2html(val) {
      var list = this.globalLableList;
      list.forEach((item, index) => {
        var label = item.key;
        var index = val.indexOf(label);

        if (index != "-1") {
          var html = [
            '<div class="ask-content-x">',
            `<span style="color: rgb(96, 105, 255)">#${item.value}#</span>`,
            '<div class="ask-icon-select">',
            item.value,
            "</div>",
            "</div>",
          ].join("");
          val = val.replace(label, html);
        }
      });
      // 自定义链接变蓝
      if(this.postForm.transformUrl) {
        if(val.indexOf(this.postForm.transformUrl)!=-1) {
          var html = [
            `<span style="color: rgb(96, 105, 255);">${this.postForm.transformUrl}</span>`,
          ].join("");
          val = val.replace(this.postForm.transformUrl, html);
        }
      }
      return val;
    },

    wareChange(val) {
      if (val == "0") {
        this.postForm.sendConditionDay = 0;
      }
    },
    enter() {
      this.imgDisplay = "inline-block";
    },
    leave() {
      this.imgDisplay = "none";
    },
    changeTotalMoneyStart(val) {
      var max = this.postForm.endProductNum;
      if (max && val >= max) {
        this.postForm.startProductNum = "";
        this.$message.warning("商品数量开始值不能大于结束值");
      }
    },

    changeTotalMoneyEnd(val) {
      var min = this.postForm.startProductNum;
      if (min && +min >= +val) {
        this.postForm.endProductNum = "";
        this.$message.warning("商品数量结束值不能小于开始值");
      }
    },
    // 上传文件成功
    handleAvatarSuccess(res, file, fileList) {},
    uploadSectionFile(params) {
      // 获取id
      getInfo().then((res) => {
        this.taskId = res.data.id;
        this.postForm.id = res.data.id;
        const file = params.file;
        let form = new FormData();
        form.append("file", file);
        form.append("id", this.postForm.id);
        importActivityCode(form)
          .then((res) => {
            if (res.code == 1) {
              console.log(res);
              this.$message.success("上传成功");
              this.postForm.activityCodeNum = res.data;
            } else {
              // fileList = [];
              console.log("err");
              // 清空文件列表，使客户可以重新上传
              this.$refs.upload.clearFiles();
              this.$message.error(res.message);
            }
          })
          .catch((err) => {});
      });
    },
    uploadError(err, file, fileList) {
      console.log(err);
    },
    getOfficialSuffix() {
      let type = 1;
      if (this.isOfficial) {
        type = 2;
      }
      getPrecisionJdSuffixList(type).then((res) => {
        if (res.code == "1") {
          var suffixList = res.data;
          console.log(suffixList);
          this.suffixList = suffixList;
          this.selSuffixName = suffixList[0];
          // this.formData.jdSmsSuffix = this.selectSuffix;
        }
      });
    },
    // 单选框监听事件
    wareType() {
      this.postForm.wareConsumeType = "";
      this.postForm.sendConditionDay = "";
      this.postForm.sendConditionHour = "";
    },
    // 选择签名
    changeSufix(item) {
      this.selSuffixName = item;
    },
    handleShowModule() {
      // 保存模板 显示
      var param = {
        type: 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.dirList = res.data;
          this.keepTmpShow = true;
        }
      });
      console.log(this.dirList);
    },
    // // 保存模板
    // savaTemplate() {
    //   this.keepTmpShow = false;
    // },
    // 保存模板隐藏
    keepTmpChange(val) {
      this.keepTmpShow = false;
      // 保存
      if (val == 1) {
        var param = {
          tid: this.keepTmpValue,
          content: this.postForm.content,
        };
        createTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("保存模板成功！");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    editOrderCare(item) {
      item.isEdit = !item.isEdit;
    },
    onDefault(item) {
      if (item.defaultPeriodDay !== null && item.defaultPeriodDay !== undefined) {
        item.periodDay = item.defaultPeriodDay;
      } else {
        this.$http
          .get("/ware/getItemBuyerRebuyAvg", {
            params: {
              numIid: item.skuId + "",
            },
          })
          .then((res) => {
            var defaultPeriodDay = res.data;
            item.periodDay = defaultPeriodDay;
            item.defaultPeriodDay = defaultPeriodDay;
          });
      }
    },
    deleteOrderCare(item) {
      let index = this.tableList.findIndex((i) => i.skuId == item.skuId);
      this.tableList.splice(index, 1);
      this.returnSelectGoodsAppoint.splice(index, 1);
      this.goodsStateLength--;
      // this.goodsStateLength1 = this.goodsStateLength1--
    },
    handleClose(done) {
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      done();
      // })
      // .catch(_ => {});
      // this.drawers = false;
      this.$emit("transferName", true);
    },
    handleClose2(done) {
      // this.$confirm('还有未保存的工作哦确定关闭吗？')
      //     .then(_ => {
      done();
      // })
      // .catch(_ => {});
      // this.drawerWidth = '780px';
    },
    oninput(num) {
      var str = num;
      var len1 = str.substr(0, 1);
      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第一位不能是.
      if (len1 == ".") {
        str = "";
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换
      str = str.replace(/[^\d^\.]+/g, ""); // 保留数字和小数点
      str = str.replace(/\.\d\d\d$/, ""); // 小数点后只能输两位
      return str;
    },
    moneyChange1() {
      if (this.postForm.startOrderMoney != "" && this.postForm.endOrderMoney != "") {
        if (this.postForm.startOrderMoney > this.postForm.endOrderMoney) {
          this.$message.warning("实付金额初始数值不能大于结束数值");
          this.postForm.startOrderMoney = "";
          this.postForm.endOrderMoney = "";
          return;
        }
      }
    },
    moneyChange() {
      console.log(1111);
      if (this.postForm.startBuyTotalCount != "" && this.postForm.endBuyTotalCount != "") {
        if (this.postForm.startBuyTotalCount > this.postForm.endBuyTotalCount) {
          this.$message.warning("商品数量初始数值不能大于结束数值");
          this.postForm.startBuyTotalCount = "";
          this.postForm.endBuyTotalCount = "";
          return;
        }
      }
    },
    checkedCity(val, type) {
      console.log("val:", val);
      console.log(type);
      if (type == "cancel") {
        return;
      } else {
        this.checkedList = val;
      }
    },
    selectGoodsChange(val, arr) {
      console.log("商品选择返回==", val, arr);
      this.goodsState = false;
      this.goodsState3 = false;
      let goodsArr = [];
      if (val || arr) {
        console.log("商品选择返回==222");
        // 已选商品表格数据
        for (let item of val) {
          let obj = {};
          obj.wareTitle = item.wareTitle || item.title;
          obj.price = item.jdPrice;
          obj.skuId = item.skuId;
          obj.wareId = item.wareId;
          obj.wareLogo = item.logo;
          obj.isEdit = false;
          obj.periodDay = item.periodDay;
          // obj.defaultPeriodDay = item.periodDay;
          goodsArr.push(obj);
        }

        // 商品复购周期
        Promise.all(
          goodsArr.map((item) =>
            this.$http.get("/ware/getItemBuyerRebuyAvg", {
              params: { numIid: item.skuId + "" },
            })
          )
        ).then((res) => {
          console.log("Promise.all", res);
          goodsArr.map((item, index) => {
            // console.log(res[index].data);
            if (this.originIds.indexOf(item.wareId) == "-1") {
              item.periodDay = res[index].data; //复购周期
              //默认复购周期
            }
            item.defaultPeriodDay = res[index].data;
          });
          this.tableList = goodsArr;
        });

        this.goodsStateLength1 = val.length;
        this.goodsStateLength = this.goodsStateLength1;
        this.returnSelectGoodsAppoint = val;
        this.postForm.itemList = val;
        if (!this.venderType && this.GoodsSkuIsflay) {
          let skuArr = [];
          val.forEach((i) => {
            if (i.skuList != 0) {
              i.skuList.forEach((ele) => {
                if (ele.skuId) {
                  skuArr.push(ele.skuId);
                } else {
                  skuArr.push(ele);
                }
              });
            }
          });
          let skuArr1 = arr.map((i) => i.skuId);
          this.goodsStateLength = this.unique(skuArr, skuArr1).length;
          this.goodsStateLength1 = this.goodsStateLength;
          this.selectGoodsSkuList = arr;
          this.postForm.itemList = [...val, ...arr];
        }
      }
    },
    selectGoodsChange1(val, arr) {
      console.log("商品选择返回==", val, arr);
      this.goodsState = false;
      this.goodsState3 = false;
      let goodsArr = [];
      if (val || arr) {
        console.log("商品选择返回==222");
        // 已选商品表格数据
        for (let item of val) {
          let obj = {};
          obj.wareTitle = item.wareTitle || item.title;
          obj.price = item.jdPrice;
          obj.skuId = item.skuId;
          obj.wareId = item.wareId;
          obj.wareLogo = item.logo;
          obj.isEdit = false;
          obj.periodDay = item.periodDay;
          // obj.defaultPeriodDay = item.periodDay;
          goodsArr.push(obj);
        }

        // 商品复购周期
        Promise.all(
          goodsArr.map((item) =>
            this.$http.get("/ware/getItemBuyerRebuyAvg", {
              params: { numIid: item.skuId + "" },
            })
          )
        ).then((res) => {
          console.log("Promise.all", res);
          goodsArr.map((item, index) => {
            // console.log(res[index].data);
            if (this.originIds.indexOf(item.wareId) == "-1") {
              item.periodDay = res[index].data; //复购周期
              //默认复购周期
            }
            item.defaultPeriodDay = res[index].data;
          });
          this.tableList = goodsArr;
        });

        this.goodsStateLength1 = val.length;
        this.goodsStateLength = this.goodsStateLength1;
        this.returnSelectGoodsAppoint = val;
        this.postForm.itemList = val;
        if (!this.venderType && this.GoodsSkuIsflay) {
          let skuArr = [];
          val.forEach((i) => {
            if (i.skuList != 0) {
              i.skuList.forEach((ele) => {
                if (ele.skuId) {
                  skuArr.push(ele.skuId);
                } else {
                  skuArr.push(ele);
                }
              });
            }
          });
          let skuArr1 = arr.map((i) => i.skuId);
          this.goodsStateLength = this.unique(skuArr, skuArr1).length;
          this.goodsStateLength1 = this.goodsStateLength;
          this.selectGoodsSkuList = arr;
          this.postForm.itemList = [...val, ...arr];
        }
      // :selectGoods="returnSelectGoodsAppoint"
      // :selectGoodsSkuList="selectGoodsSkuList"
        if(arr == undefined){
          this.returnSelectGoodsAppoint = []
          this.selectGoodsSkuList = val
          this.postForm.itemList = [];
          this.postForm.itemList = [...val];
          this.goodsStateLength = this.postForm.itemList.length
        }else{
          this.returnSelectGoodsAppoint = []
          this.returnSelectGoodsAppoint = val
          this.selectGoodsSkuList = arr
          this.postForm.itemList = [];
          this.postForm.itemList = [...val, ...arr];
          this.goodsStateLength = this.postForm.itemList.length
        }
      }
    },
    selectGoodsChange2(val, arr) {
      console.log("确认")
      this.goodsState2 = false;
      if (val || item) {
        console.log("商品选择返回==222");
        this.postForm.itemList = val;
        this.goodsStateLength2 = val.length;
        this.goodsStateLength = this.goodsStateLength2;
        this.returnSelectGoodsExclude = val;
        if (!this.venderType && this.GoodsSkuIsflay) {
          let skuArr = [];
          val.forEach((i) => {
            if (i.skuList != 0) {
              i.skuList.forEach((ele) => {
                if (ele.skuId) {
                  skuArr.push(ele.skuId);
                } else {
                  skuArr.push(ele);
                }
              });
            }
          });
          let skuArr1 = arr.map((i) => i.skuId);
          this.goodsStateLength = this.unique(skuArr, skuArr1).length;
          this.goodsStateLength1 = this.goodsStateLength;
          this.selectGoodsSkuExclude = arr;
          this.postForm.itemList = [...val, ...arr];
        }
        if(arr == undefined){
          this.returnSelectGoodsExclude = []
          this.selectGoodsSkuExclude = val
          this.postForm.itemList = [];
          this.postForm.itemList = [...val];
          this.goodsStateLength = this.postForm.itemList.length
        }else{
          this.returnSelectGoodsExclude = val
          this.selectGoodsSkuExclude = arr
          this.postForm.itemList = [];
          this.postForm.itemList = [...val, ...arr];
          this.goodsStateLength = this.postForm.itemList.length
        }
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`只能上传一个文件`);
    },
    moneyPayTimeChange() {
      let start = new Date(this.postForm.moneyPayStartTime).valueOf();
      let end = new Date(this.postForm.moneyPayEndTime).valueOf();
      if (end < start) {
        this.$message.warning("开始时间不得大于结束时间");
        this.postForm.moneyPayStartTime = "";
      }

      let start2 = new Date(this.postForm.taskStartTime).valueOf();
      let end2 = new Date(this.postForm.taskEndTime).valueOf();
      if (end2 < start2) {
        this.$message.warning("开始时间不得大于结束时间");
        this.postForm.taskStartTime = "";
      }
    },
    // 保存模板隐藏
    templateChange(val, item) {
      console.log("选择模板的返回==", val, item);
      // this.inputContent = item.content;
      if (val == true) {
        this.longlinkFlay = item.content.indexOf("#LandingPage#") > -1 ? true : false;
        this.longUrllink = "";
        this.postForm.transformUrl = "";
        this.selectTemplate = item;
        this.postForm.content = item.content;
        this.postForm.templateId = item.officialTemplateId;
      }
      this.templateShow = false;
    },
    clearTime() {
      // this.smsSearchParams.sendStartTime = "";
      // this.smsSearchParams.sendEndTime = "";
      // this.taskTimeChange = ["",""],
      // this.taskTimeChange[1] = "";
      this.postForm.taskStartTime = "";
      this.postForm.taskEndTime = "";
    },
    // 订金支付时间的清空
    clearTime2() {
      this.postForm.moneyPayStartTime = "";
      this.postForm.moneyPayEndTime = "";
    },

    // 限制结束时间要大于开始时间
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.postForm.filterCreatedStart) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.postForm.filterCreatedStart).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },

    showSelectGoods() {
      if (this.postForm.isAllItem == "1") {
        this.goodsState = true;
        this.goodsState2 = false;
        // this.returnSelectGoodsAppoint = this.returnSelectGoods
      }
      if (this.postForm.isAllItem == "2") {
        this.goodsState2 = true;
        // this.returnSelectGoods = this.returnSelectGoodsExclude
      }
      this.GoodsSkuIsflay = true;
    },
    difNumberBluer(item) {
      // console.log(this.postForm[item]);
      if (!this.postForm[item] || this.postForm[item] == "") {
        this.postForm[item] = 0;
      }
      this.postForm[item] = Number(this.postForm[item]) > 10000000 ? 10000000 : Number(this.postForm[item]);

      this.postForm[item] = Number(this.postForm[item]) > 10000000 ? 10000000 : Number(this.postForm[item]);
    },
    //疑难杂件
    difficultCity(v) {
      if (this.difficultType == 1) {
        this.postForm.unReceiptedZip = v;
        // console.log(this.postForm.unReceiptedZip);
      } else if (this.difficultType == 2) {
        this.postForm.unUpdateZip = v;
        // console.log(this.postForm.unUpdateZip);
      } else {
      }
    },
    //疑难件地区选择 1//2
    difficult(type) {
      let t = Number(type);
      this.difficultType = t;
      //未签收
      //this.checkedList = [];
      //       unReceiptedZip (string, optional): 疑难件提醒 未签收地区编码 ,
      // unUpdateZip (string, optional): 疑难件提醒 未更新地区编码 ,
      //this.postForms.unReceiptedZip

      // this.areaState = true;

      this.areaState = false;
      this.$nextTick(() => {
        this.areaState = true;
      });

      this.difficultType = t;
      if (type == 1) {
        // console.log(this.checkedList, "-----------");
        this.checkedList = this.postForm.unReceiptedZip || [];
        //未更新
      } else if (type == 2) {
        this.checkedList = this.postForm.unUpdateZip || [];
      }
    },

    getNowDate() {
      var date = new Date();
      var seperator1 = "";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();

      if (Hours >= 0 && Hours <= 9) {
        Hours = "0" + Hours;
      }
      if (Minutes >= 0 && Minutes <= 9) {
        Minutes = "0" + Minutes;
      }
      if (Seconds >= 0 && Seconds <= 9) {
        Seconds = "0" + Seconds;
      }
      var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + " " + Hours + seperator2 + Minutes + seperator2 + Seconds;
      return currentdate;
    },
    msToDate(msec) {
      let datetime = new Date(msec);
      let year = datetime.getFullYear();
      let month = datetime.getMonth();
      let date = datetime.getDate();
      let hour = datetime.getHours();
      let minute = datetime.getMinutes();
      let second = datetime.getSeconds();

      let result1 =
        year +
        "-" +
        (month + 1 >= 10 ? month + 1 : "0" + (month + 1)) +
        "-" +
        (date + 1 < 10 ? "0" + date : date) +
        " " +
        (hour + 1 < 10 ? "0" + hour : hour) +
        ":" +
        (minute + 1 < 10 ? "0" + minute : minute) +
        ":" +
        (second + 1 < 10 ? "0" + second : second);

      let result2 = year + "-" + (month + 1 >= 10 ? month + 1 : "0" + (month + 1)) + "-" + (date + 1 < 10 ? "0" + date : date);

      let result = {
        hasTime: result1,
        withoutTime: result2,
      };

      return result;
    },
    //最后一天
    getCurrentMonthLast() {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      return new Date(nextMonthFirstDay - oneDay);
    },
    getCurrentMonthFirst() {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return date.getFullYear() + "-" + month + "-" + day;
    },

    checkReturnShow(arr) {
      if (this.postForm[arr].length == 0) {
        this.postForm[arr] = [""];
      }
    },

    changeCheckBox(v, arr) {
      //arr VM 传入数组
      // console.log(v, arr);
      if (v[v.length - 1] === "" || v.length === 0) {
        this.postForm[arr] = [""];
        return;
      }
      for (let i = 0; i < v.length; i++) {
        if (v.length >= 2 && v[i] == "") {
          this.postForm[arr].splice(i, 1);
        }
      }
    },

    //编辑短信输入
    sendInfoText(v) {
      //this.sendInfoLength = v.length + this.selSuffixName.length;
      if (this.inputContent.indexOf("【") != -1 || this.inputContent.indexOf("】") != -1) {
        this.$message.info("通道规则：短信内容请勿包含【】符号！"); //不能输入【】符号,自动去除
        this.inputContent = this.inputContent.replace(/[【】]/g, "");
      }
      if (v.length + this.selSuffixName.length > 70) {
        document.getElementById("copyIndexInfo").style.color = "red";
      } else {
        document.getElementById("copyIndexInfo").style.color = "#606266";
      }
      //       var str = "123";
      // console.log(str.search("3") != -1 );
      let text = v;
      this.getInputFilterList = [];
      for (let i = 0; i < this.filterWordsList.length; i++) {
        if (text.search(this.filterWordsList[i].word) != -1) {
          this.getInputFilterList.push(this.filterWordsList[i]);
        } else {
          this.getInputFilterList.splice(i, 1);
        }
      }
    },

    //获取编写
    getFourIndex() {
      var oTxt1 = document.getElementById("copyIndexInfo");
      this.cursurPosition = -1;
      if (oTxt1.selectionStart) {
        //非IE浏览器
        this.cursurPosition = oTxt1.selectionStart;
      } else {
        //IE
        try {
          var range = document.selection.createRange();
          range.moveStart("character", -$input.value.length);
          this.cursurPosition = range.text.length;
        } catch (e) {
          this.cursurPosition = 0;
        }
      }
    },
    selectTagTap(tagName) {
      //insert short

      //指定插入位置
      let insertStr = (soure, start, newStr) => {
        return soure.slice(0, start) + newStr + soure.slice(start);
      };
      this.postForm.content = insertStr(this.postForm.content, this.getFocusIndex(), tagName);

      this.postForm.content = this.postForm.content.substr(0, 500);
      (this.cursurPosition = this.getFocusIndex() + tagName.length),
        this.$nextTick(() => {
          this.set_text_value_position("copyIndexInfo", this.cursurPosition);
        });
    },
    //正整数0-30
    filterBuyerDay(item) {
      let num = Number(this.postForm[item]);
      if (num <= 30 && num >= 0) {
        this.postForm[item] = num;
      } else {
        this.postForm[item] = 0;
      }
    },
    //正整数0-720
    filterBuyerTime(v) {
      let num = Number(this.postForm.filterBuyerTime);
      if (num <= 720 && num >= 0) {
        this.postForm.filterBuyerTime = num;
      } else {
        this.postForm.filterBuyerTime = 0;
      }
    },
    //过滤二选一
    filterCondiions(v) {
      // console.log(v[v.length - 1]);
      for (let i = 0; i < v.length; i++) {
        if (v[v.length - 1] == "0") {
          if (v[i] == "1") {
            this.postForm.filterCondition.splice(i, 1);
          }
        }
        if (v[v.length - 1] == "1") {
          if (v[i] == "0") {
            this.postForm.filterCondition.splice(i, 1);
          }
        }
      }
    },
    //自定义地区
    customArea(v) {
      if (v == 3) {
        this.popupShowBtn();
        return;
      }
    },

    selGoods(value) {
      console.log(value, 6666666);
      if (value == 0) {
        this.isShowSelectGoods = false;
        this.returnSelectGoods = [];
      }
      if (value == 1 && !this.goodsState) {
        this.goodsStateLength = this.goodsStateLength1;
        this.returnSelectGoods = this.returnSelectGoodsAppoint;
        this.isShowSelectGoods = true;
      }
      if (value == 2 && !this.goodsState) {
        this.goodsStateLength = this.goodsStateLength2;
        this.returnSelectGoods = this.returnSelectGoodsExclude;
        this.isShowSelectGoods = true;
      }
    },
    //标准时间转时间
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      // return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
      return this.formatTen(hour) + ":" + this.formatTen(minute) + ":" + this.formatTen(second);
    },
    remindTimeTips(v) {
      console.log("v11111==", v);
      console.log(this.formatDate(v));
      console.log(typeof v);
      console.log(this.postForm.startRemindTime);
      if (v) {
        this.maxStartRemindTime = this.formatDate(v);
        this.postForm.endRemindTime = "";
      }
      // if (

      //   this.postForm.startRemindTime === null ||
      //   this.postForm.endRemindTime === null
      // ) {
      //   this.$message.error("发送时段不允许为空");
      // }
    },
    sendConditionTips() {
      if (this.postForm.sendCondition === "") {
        this.$message.error("发送时间不允许为空");
      }
    },
    sendConditionTips2() {
      if (this.postForm.sendCondition2 === "") {
        this.$message.error("发送时间不允许为空");
      }
    },
    blueNumbre(vm) {
      this.postForm[vm] = this.postForm[vm].replace(/[^\d]/g, "");
      this.postForm[vm] = this.postForm[vm] < 10000 ? this.postForm[vm] : 10000;
    },
    difNumber() {
      try {
        this.postForm.unreceiptedTime = this.postForm.unreceiptedTime.replace(/[^\.\d]/g, "");
        this.postForm.unreceiptedTime = this.postForm.unreceiptedTime.replace(".", "");
        this.postForm.notUpdatedTime = this.postForm.notUpdatedTime.replace(/[^\.\d]/g, "");
        this.postForm.notUpdatedTime = this.postForm.notUpdatedTime.replace(".", "");
      } catch (error) {}
    },
    filNumber() {
      // console.log("input==");
      this.postForm.sendCondition = this.postForm.sendCondition.replace(/[^\.\d]/g, "");
      this.postForm.sendCondition = this.postForm.sendCondition.replace(".", "");

      this.postForm.sendCondition2 = this.postForm.sendCondition2.replace(/[^\.\d]/g, "");
      this.postForm.sendCondition2 = this.postForm.sendCondition2.replace(".", "");

      //商品数量只能输入正整数
      this.postForm.startProductNum = this.postForm.startProductNum.replace(/[^\d]/g, "");
      this.postForm.endProductNum = this.postForm.endProductNum.replace(/[^\d]/g, "");
    },
    changeIsTwo() {
      let _that = this;
      let sendTime = 1;
      let sendBtnTimer = setInterval(changeSendBtn, 200);
      function changeSendBtn() {
        if (sendTime <= 0) {
          _that.isTwo = false;
          // console.log('清除定时器');
          clearInterval(sendBtnTimer);
          return false;
        }
        sendTime--;
        // console.log(sendTime)
      }
    },
    /**
     * 返回上一步
     */
    backOne() {
      // this.changeIsTwo();
      // $(".myOne").slideToggle(500);
      // this.handleClose2();
      this.innerDrawer = false;
    },
    /**
     * 自定义地区
     */
    getTransferName(event) {
      this.areaState = false;
      if (event.type !== 1) {
        if (event.data.length !== 0) {
          this.areaStateLength = event.data.length;
          this.areaList = event.data;
          let currentStr = event.data;
          this.postForm.zip = currentStr.join(",");
        }
        this.areaStateLength = event.data.length;
      }
    },
    changeStr(allstr, start, end, str, changeStr) {
      //allstr:原始字符串，start,开始位置,end:结束位  置,str:要改变的字，changeStr:改变后的字
      if (allstr.substring(start - 1, end - 1) == str) {
        return allstr.substring(0, start - 1) + changeStr + allstr.substring(end, allstr.length);
      } else {
        allstr;
      }
    },
    //设置光标位置
    set_text_value_position(obj, spos) {
      var tobj = document.getElementById(obj);
      if (spos < 0) spos = tobj.value.length;
      if (tobj.setSelectionRange) {
        //兼容火狐,谷歌
        setTimeout(function() {
          tobj.setSelectionRange(spos, spos);
          tobj.focus();
        }, 0);
      } else if (tobj.createTextRange) {
        //兼容IE
        var rng = tobj.createTextRange();
        rng.move("character", spos);
        rng.select();
      }
      //copyIndexInfo
    },

    //获取编写
    getFocusIndex() {
      var oTxt1 = document.getElementById("copyIndexInfo");
      let cursurPosition = -1;
      if (oTxt1.selectionStart) {
        //非IE浏览器
        return (cursurPosition = oTxt1.selectionStart);
      } else {
        //IE
        try {
          var range = document.selection.createRange();
          range.moveStart("character", -$input.value.length);
          return (cursurPosition = range.text.length);
        } catch (e) {
          return (cursurPosition = 0);
        }
      }
    },
    logiLinkFn(v) {
      this.logiState = v;
      this.$children.linkDialog = v;
    },
    logiLinkFn(v) {
      //指定插入位置
      let insertStr = (soure, start, newStr) => {
        return soure.slice(0, start) + newStr + soure.slice(start);
      };

      this.postForm.content = insertStr(this.postForm.content, this.getFocusIndex(), v);
      this.postForm.content = this.postForm.content.substr(0, 500);
      // (this.cursurPosition = this.getFocusIndex() + v.length),
      //   this.$nextTick(() => {
      //     this.set_text_value_position("copyIndexInfo", this.cursurPosition);
      //   });
      if (this.lastInsertLink != "") {
        this.postForm.content = this.postForm.content.replace(this.lastInsertLink, "");
      }
      this.logisticsLinkDialog = false;
      this.lastInsertLink = v;
    },

    /***
     * 发送测试短信
     * */
    testSend() {
      // 判断内容和手机号码都不能为空\
      // 判断内容和手机号码都不能为空\
      var mobiles = this.smsTestSendParams.mobiles;

      if (!/[\S]+/.test(mobiles)) {
        this.$message.warning("手机号不能为空，请输入正确的手机号 !");
        return;
      }
      mobiles.split(",").forEach((element) => {
        if (!/^1[3456789]\d{9}$/.test(element)) {
          this.$message.warning("请输入正确的手机号 !");
          return;
        }
      });
      var content = this.postForm.content;
      if (content.indexOf('#LandingPage#') != -1) {
        this.$message.error("请先插入短网址");
        return;
      }
      if (content && content.trim().length > 0) {
        this.phoneLenght = this.smsTestSendParams.mobiles.split(",").length;
        // 不能含有【 或 】 的字符
        if (content.indexOf("【") !== -1 || content.indexOf("】") !== -1) {
          this.$message.error("通道规则：短信内容请勿包含【】符号！");
          return;
        }
        this.showSendConfirm = true;
      } else {
        this.$message.warning("短信内容不能为空哦！");
      }
    },

    // 确认发送弹窗确认按钮
    handleSendConfirm() {
      this.showSendConfirm = false;
      // 测试发送  预提交发送
      const params = {
        dataFrom: 0,
        sendType: 0,
        mobiles: this.smsTestSendParams.mobiles.split(","),
      };
      console.log(params);
      // return
      // preCommit(params).then((res) => {
      let postData = {
        content: this.postForm.content+'拒收请回复R',
        // jdSmsSuffix: this.formData.jdSmsSuffix,
        mobile: params.mobiles.join(','),
        checkInvalidChar:false,
      }
      // 短信测试新接口
      NewPreCommit(postData).then((res) => {
        if (res.code == "1") {
          // this.preData.sendObjectCount = res.data.sendObjectCount;
          // this.preData.sendObjectId = res.data.sendObjectId;

          // this.sendPeopleNum = res.data.sendObjectCount;
          // let params2 = {
          //   content: this.postForm.content + "",
          //   sendObjectId: res.data.sendObjectId,
          //   smsSuffix: this.selSuffixName,
          //   blackFlag: false,
          //   smsType: 0
          // };
          // platformSend(params2).then((res) => {
          //   if (res.code == "1") {
              this.$message.success(res.data);
          //   } else {
          //     this.$message.error(res.message);
          //   }
          // });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /***
     * 保存并开启
     * */

    //屏蔽黑名单 查看
    routerLinkOne() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
      });
      window.open(routeUrl.href, "_blank");
    },

    ///保存检查
    async saveTap(v) {
      if (this.disBtn1) {
        return;
      }
      if (this.disBtn2) {
        return;
      }
      if (this.postForm.content == "") {
        this.$message.error("短信内容不能为空");
        return;
      }
      if (this.postForm.content.indexOf('#LandingPage#') != -1) {
        this.$message.error("请先插入短网址");
        return;
      }
      this.saveTapPost(v);
    },

    /***
     * 保存任务
     * */
    saveTapPost(v) {
      //this.postForm.isOpen = 0;
      console.log(this.postForm);
      this.disBtn1 = true;
      this.disBtn2 = true;
      v == 0 ? (this.loadBtn2 = true) : (this.loadBtn1 = true);
      // let obj = { ...this.postForm };
      let obj = { ...this.postForm, url: this.longUrllink };
      obj.content = this.longlinkFlay ? this.postForm.content.replace(` ${this.postForm.transformUrl} `, `#LandingPage#`) : this.postForm.content;
      let regex = /\【|】/g;
      //let a=regex.test(obj.content);
      if (regex.test(obj.content)) {
        this.$message.error("通道规则：短信内容请勿包含【】符号！");
        return;
      }
      // obj.startRemindTime = obj.startRemindTime
      //   ? this.formatDate(obj.startRemindTime)
      //   : null;
      // obj.endRemindTime = obj.endRemindTime
      //   ? this.formatDate(obj.endRemindTime)
      //   : null;
      // //布尔值转换
      // for (let key in obj) {
      //   if (obj[key] == "") {
      //     obj[key] = null;
      //   }
      // }
      let booleanData = {
        1: "isBuyerMessage",
        2: "isLunchBreak",
        3: "isOrderMoney",
        4: "isProductNum",
        5: "isSellerRemark",
        6: "isDefaultGoodRate",
        7: "isGoodNumber",
        8: "isGoodDays",
        9: "evaluateWhetherToSend",
      };
      for (let key in booleanData) {
        if (booleanData[key] == "evaluateWhetherToSend") {
          obj[booleanData[key]] = obj[booleanData[key]] ? "0" : "1";
        } else {
          obj[booleanData[key]] = obj[booleanData[key]] ? "1" : "0";
        }
      }

      if (obj.filterCondition && obj.filterCondition.length > 0) {
        try {
          obj.filterBuyerTime = obj.filterCondition.includes("5") ? obj.filterBuyerTime : null;
          obj.filterWantTime = obj.filterCondition.includes("0") ? obj.filterWantTime : null;
          obj.filterMobileTime = obj.filterMobileTime.includes("1") ? obj.filterMobileTime : null;
        } catch (e) {}
      }
      if (!obj.filterCondition || !obj.filterCondition.length) {
        try {
          obj.filterBuyerTime = null;
          obj.filterWantTime = null;
          obj.filterBeyondWords = null;
          obj.filterBlockWord = null;
          obj.filterMobileTime = null;
        } catch (e) {}
      }

      //数组转对象值
      let arrChangeObj = {
        1: "sellerFlag",
        2: "filterCondition",
        3: "memberLevel",
        4: "tradeFrom",
        5: "reasonReturn",
      };

      // //数组转字符串
      for (let key in arrChangeObj) {
        try {
          obj[arrChangeObj[key]] = obj[arrChangeObj[key]].filter((item) => item != "");
        } catch (e) {}
        this.$nextTick(() => {
          obj[arrChangeObj[key]] = obj[arrChangeObj[key]] ? obj[arrChangeObj[key]].join(",") : "";
        });
      }
      if (obj.remindSellerConfigId && v == 0) {
        obj.isOpen = obj.isOpen;
      } else {
        obj.isOpen = v;
      }
      obj.isNoteReply = this.isNoteReply ? "0" : "1";
      if (obj.isProductNum == "0") {
        obj.startProductNum = null;
        obj.endProductNum = null;
      }
      if (obj.isOrderMoney == "0") {
        obj.startOrderMoney = null;
        obj.endOrderMoney = null;
      }
      if (obj.isGoodNumber == "0") {
        obj.goodNumber = null;
      }
      if (obj.isGoodDays == 0) {
        obj.goodDays = null;
      }
      if (obj.evaluateWhetherToSend == 1) {
        obj.evaluateWhetherToSend = null;
      }
      if (obj.orderType == "0" || obj.orderType == "2") {
        obj.presellType = null;
      }
      if (obj.areaType == "1") {
        obj.zip = JZH_CODE;
      }
      if (obj.areaType == "2") {
        obj.zip = PY_CODE;
      }
      if (obj.areaType == "3") {
        obj.zip = this.checkedList;
      }
      this.$nextTick(() => {
        obj.sellerFlag = obj.sellerFlag ? obj.sellerFlag : null;
        obj.filterCondition = obj.filterCondition ? obj.filterCondition : null;
        obj.memberLevel = obj.memberLevel ? obj.memberLevel : null;
        obj.tradeFrom = obj.tradeFrom ? obj.tradeFrom : null;
      });

      obj.taskType = obj.taskType == 1 ? 1 : 0;
      obj.orderSplitCondition = obj.orderSplitCondition ? "1" : "2";
      if (this.menuType == 7) {
        obj.tradeFrom = "JHS";
      }
      if (this.menuType != 12) {
        obj.unReceiptedZip = null;
        obj.unUpdateZip = null;
        obj.unreceiptedTime = null;
        obj.unreceiptedUnit = null;
        obj.notUpdatedTime = null;
        obj.notUpdatedUnit = null;
      }

      obj.paymentType = this.menuType == 6 ? obj.paymentType : null;
      console.log(this.menuType);
      if (this.menuType == 9) {
        console.log(obj.filterCondition);
        // return
        let params = {
          dayLimit:obj.dayLimit,
          activityCodeNum: obj.activityCodeNum, //活动码数量
          // activityCodeWareVoList: [],
          activityName: obj.taskName, //活动名称
          activitySendTimeStart: obj.startRemindTime, //发送时段开始
          activitySendTimeEnd: obj.endRemindTime, //发送时段结束
          activityTimeStart: obj.taskStartTime, //活动时间开始
          activityTimeEnd: obj.taskEndTime, //活动时间结束
          appointAreaType: obj.areaType, //指定地区
          content: obj.content, //短信内容
          customerType: "0", //不发送客户类型
          filterSendType: obj.isLunchBreak, //是否开启午休时间过滤
          filterSendTimeStart: obj.startLunchBreak, //午休时间开始
          filterSendTimeEnd: obj.endLunchBreak, //午休时间结束
          id: obj.id, //任务id
          orderMoneyFilterType: obj.isOrderMoney, //是否开启实付金额过滤
          orderMoneyStart: obj.startOrderMoney, //实付金额下限
          orderMoneyEnd: obj.endOrderMoney, //实付金额上限
          participationType: 0, //是否开启参与次数限制
          participationNumber: null, //参与次数
          filterPayType: 0, //是否开启付款类型过滤
          payTypeFilterData: null, //要过滤的付款类型集合
          filterWareType: obj.isAllItem, //过滤商品
          isOpen: obj.isOpen ? obj.isOpen : 1, //"0关闭 1开启"
          persistentOpenFlag: obj.taskType == 0 ? true : false, //是否持续开启标记
          // sendCount: null,
          // sendNumberType: 0,

          sendTimeType: obj.activitySendTimeType, //发送时间类型

          // sendTimeTypeRemark: null,
          suffix: "【" + this.selSuffixName + "】", //签名
          // updateTime: "2020-09-15 13:36:38",
          // 商品数量
          wareNumberConfigType: obj.isProductNum,
          wareNumberEnd: obj.startProductNum,
          wareNumberStart: obj.endProductNum,
        };
        // 是否开启付款类型过滤
        console.log(obj);
        if (obj.payType.length != 0) {
          params.filterPayType = 1;
          params.payTypeFilterData = obj.payType.join(",");
        } else {
          params.filterPayType = 0;
          params.payTypeFilterData = "0";
        }
        console.log(obj.isAllItem);
        // return
        // 添加地区
        if (obj.areaType != 0) {
          addActivity({
            activityCodeConfigId: obj.id,
            provinceCodes: obj.zip,
          }).then((res) => {});
        }
        // 选择商品项不为全部商品
        if (obj.isAllItem != 0) {
          if (obj.isAllItem == 1) this.postForm.itemList = [...this.returnSelectGoodsAppoint, ...this.selectGoodsSkuList];
          if (obj.isAllItem == 2) this.postForm.itemList = [...this.returnSelectGoodsExclude, ...this.selectGoodsSkuExclude];
          params.goodData = this.postForm.itemList.map((res) => {
            // return {
            //   itemUrl: res.logo,
            //   wareTitle: res.wareTitle,
            //   jdPrices: res.jdPrice,
            //   skuId: res.skuId,
            //   wareId: res.wareId,
            // };
            let obj = {
              jdPrices: res.jdPrice || res.price,
              wareId: res.wareId,
              itemUrl: res.logo || res.wareLogo,
              wareTitle: res.wareTitle,
              skuId: res.skuList && res.skuList.length ? res.skuList.map((val) => val.skuId).join(",") : res.skuId,
            };
            return obj;
          });
        } else {
          params.goodData = [];
        }
        //不发送客户过滤设置
        if (obj.filterCondition.length != 0) {
          let arr = [];
          obj.filterCondition.map((item) => {
            if (item == 2) {
              arr.push(1);
            }
            if (item == 3) {
              arr.push(2);
            }
            if (item == 1) {
              arr.push(3);
            }
            if (item == 4) {
              params.participationType = 1;
              params.participationNumber = obj.participationNumber;
            }
          });
          params.customerType = arr.join(",");
        }
        updateActivityCodeConfig(params)
          .then((res) => {
            this.disBtn1 = false;
            this.disBtn2 = false;
            this.loadBtn1 = false;
            this.loadBtn2 = false;
            res.code === 1 ? (this.$message.success(res.message), this.ModularBtn()) : this.$message.error(res.message);
          })
          .catch((error) => {
            this.disBtn1 = false;
            this.disBtn2 = false;
            this.loadBtn1 = false;
            this.loadBtn2 = false;
          });
      }
      // 商品复购模块
      else if (this.menuType == 1) {
        console.log(obj);
        console.log("obj.isFilterFreeGoods", obj.isFilterFreeGoods);
        let params = {
          dayLimit:obj.dayLimit,
          taskName: obj.taskName,
          persistentOpenFlag: obj.taskType == 0 ? true : false, //任务时间类型
          taskAllowRunEndTime: obj.taskEndTime, //任务开始时间
          taskAllowRunStartTime: obj.taskStartTime, //任务结束时间
          warePeriodType: obj.warePeriodType, //商品复购类型
          wareConsumeType: obj.wareConsumeType, //商品消耗完发送类型
          wareConsumeDay: obj.sendConditionDay, //商品消耗天数
          // sendTime: obj.warePeriodType == '1' ? obj.sendConditionHour: obj.sendConditionHour2,                         //发送时间
          sendTime: obj.sendConditionHour, //发送时间
          filterBlacklistType: false, //屏蔽黑名单
          isFilterPeriodBuyer: false, //是否过滤周期内有购买原商品客户
          warePeriodList: this.tableList.map((res) => {
            //商品周期的商品列表
            return {
              price: res.price,
              skuId: res.skuId,
              wareId: res.wareId,
              wareLogo: res.wareLogo,
              wareTitle: res.wareTitle,
              periodDay: res.periodDay,
            };
          }),
          condit: "0",
          clearWare: false,
          content: obj.content,
          isOpen: v,
          id: obj.id,
          suffix: "【" + this.selSuffixName + "】", //签名
          type: this.taskTypeActive,

          sendOpportunity: obj.sendOpportunity,
          sendTimeType: obj.sendUnitTime3,
          appointAreaType: obj.areaType == 0 ? 0 : 1,
          bargainTimeEnd: obj.moneyPayEndTime,
          bargainTimeStart: obj.moneyPayStartTime,
          sendDays: obj.sendDays,
          buyTotalCountType: obj.dealCount ? 1 : 0,
          startBuyTotalCount: obj.startBuyTotalCount,
          endBuyTotalCount: obj.endBuyTotalCount,

          buyerRemarkConfig: obj.buyerMessage,
          buyerRemarkFilterType: obj.isBuyerMessage,
          buyerRemarkIsSend: obj.isBuyerMessageSend == "1" ? true : false,
          // "extnoSendConfig": 0,

          filterSendType: obj.isLunchBreak,
          startFilterSendConfig: obj.startLunchBreak,
          endFilterSendConfig: obj.endLunchBreak,
          // remindSendType: obj.remindSendType == "1" ? 0 : 1,
          // 过滤设置
          sendRequencyType: 0,
          isFilterFreeGoods: obj.isFilterFreeGoods,

          gradeData: obj.RemindLevel.join(","),
          isAllItem: obj.isAllItem,
          orderMoneyEnd: obj.endOrderMoney,
          orderMoneyFilterType: obj.isOrderMoney,
          orderMoneyStart: obj.startOrderMoney,
          otherOrderAlreadyPaymentSend: false,
          payTypeFilterData: obj.payType ? obj.payType.join(",") : "",
          // provinceCodes: obj.zip.length != 0 ? obj.zip.split(",") : [],
          provinceCodes: obj.zip.length != 0 ? obj.zip : [],
          // remindSendEnd: obj.endRemindTime,
          // remindSendStart: obj.startRemindTime,
          sellerCode: obj.logisticsNum,

          venderRemarkConfig: obj.sellerRemark,
          venderRemarkFilterType: obj.isSellerRemark,
          sellerRemarkIsSend: obj.isSellerRemarkSend == "1" ? true : false,

          wareNumberConfigType: obj.isProductNum,
          startWareNumberConfig: obj.startProductNum,
          endWareNumberConfig: obj.endProductNum,

          // "wareList": obj.zip?obj.zip.split(","):[],
          waybillType: obj.shipmentNum,
          templateId: obj.templateId,

          url: obj.url ? obj.url : "",
          transformUrl: obj.transformUrl ? obj.transformUrl : "",
          memberSelect:String(obj.memberSelect),
          memberSelectLevel: obj.memberSelectLevel.join(","),
        };
        // 过滤黑名单
        if (obj.filterCondition.indexOf("1") != -1) {
          params.filterBlacklistType = true;
        }
        // 过滤周期内有购买原商品客户
        if (obj.filterCondition.indexOf("2") != -1) {
          params.isFilterPeriodBuyer = true;
        }
        console.log("params", params.isFilterFreeGoods);
        addOrdersCare(params)
          .then((res) => {
            this.disBtn1 = false;
            this.disBtn2 = false;
            this.loadBtn1 = false;
            this.loadBtn2 = false;
            res.code === 1 ? (this.$message.success(res.message), this.ModularBtn()) : this.$message.error(res.message);
          })
          .catch((e) => {
            this.disBtn2 = false;
            this.disBtn1 = false;
            this.loadBtn1 = false;
            this.loadBtn2 = false;
            // console.log(e);
          });
      } else {
        // console.log(obj.dealCount);
        // return
        console.log(obj);
        let params = {
          dayLimit:obj.dayLimit,
          taskName: obj.taskName,
          persistentOpenFlag: obj.taskType == 0 ? true : false,
          taskAllowRunEndTime: obj.taskEndTime,
          taskAllowRunStartTime: obj.taskStartTime,
          sendOpportunity: obj.sendOpportunity,
          sendTimeType: obj.sendUnitTime3,
          appointAreaType: obj.areaType == 0 ? 0 : 1,
          bargainTimeEnd: obj.moneyPayEndTime,
          bargainTimeStart: obj.moneyPayStartTime,
          sendDays: obj.sendDays,
          sendTime: obj.sendTime,
          buyTotalCountType: obj.dealCount ? 1 : 0,
          startBuyTotalCount: obj.startBuyTotalCount,
          endBuyTotalCount: obj.endBuyTotalCount,

          buyerRemarkConfig: obj.buyerMessage,
          buyerRemarkFilterType: obj.isBuyerMessage,
          buyerRemarkIsSend: obj.isBuyerMessageSend == "1" ? true : false,
          condit: "0",
          content: obj.content,
          // "extnoSendConfig": 0,

          clearWare: false,
          filterSendType: obj.isLunchBreak,
          startFilterSendConfig: obj.startLunchBreak,
          endFilterSendConfig: obj.endLunchBreak,
          // remindSendType: obj.remindSendType == "1" ? 0 : 1,
          // 过滤设置
          sendRequencyType: 0,
          filterBlacklistType: true,
          isFilterPeriodBuyer: false, //是否过滤周期内有购买原商品客户

          gradeData: obj.RemindLevel.join(","),
          isAllItem: obj.isAllItem,
          isOpen: v,
          orderMoneyEnd: obj.endOrderMoney,
          orderMoneyFilterType: obj.isOrderMoney,
          orderMoneyStart: obj.startOrderMoney,
          otherOrderAlreadyPaymentSend: false,
          payTypeFilterData: obj.payType ? obj.payType.join(",") : "",
          // provinceCodes: obj.zip.length != 0 ? obj.zip.split(",") : [],
          provinceCodes: obj.zip.length != 0 ? obj.zip : [],
          // remindSendEnd: obj.endRemindTime,
          // remindSendStart: obj.startRemindTime,
          sellerCode: obj.logisticsNum,

          venderRemarkConfig: obj.sellerRemark,
          venderRemarkFilterType: obj.isSellerRemark,
          sellerRemarkIsSend: obj.isSellerRemarkSend == "1" ? true : false,
          wareNumberConfigType: obj.isProductNum,
          startWareNumberConfig: obj.startProductNum,
          endWareNumberConfig: obj.endProductNum,

          suffix: "【" + this.selSuffixName + "】", //签名
          type: this.taskTypeActive,
          // "wareList": obj.zip?obj.zip.split(","):[],
          waybillType: obj.shipmentNum,
          id: obj.id,
          templateId: obj.templateId,

          url: obj.url ? obj.url : "",
          transformUrl: obj.transformUrl ? obj.transformUrl : "",
          memberSelect:String(obj.memberSelect),
          memberSelectLevel: obj.memberSelectLevel.join(","),
        };
        if (this.menuType == 8) {
          (params.buyTotalMoneyType = obj.isOrderMoney),
            (params.startBuyTotalMoney = obj.startOrderMoney),
            (params.endBuyTotalMoney = obj.endOrderMoney),
            delete params["orderMoneyEnd"];
          delete params["orderMoneyFilterType"];
          delete params["orderMoneyStart"];
        }
        if (this.menuType != 1 && this.menuType != 5 && this.menuType != 4 && this.menuType != 6 && this.menuType != 7 && this.menuType != 8) {
          params.remindSendType = obj.remindSendType == "1" ? 0 : 1;
          params.remindSendEnd = obj.endRemindTime;
          params.remindSendStart = obj.startRemindTime;
        }
        console.log(obj.endRemindTime, obj.startRemindTime);
        // 过滤黑名单
        if (obj.filterCondition.indexOf("1") == -1) {
          params.filterBlacklistType = false;
        }
        // 过滤周期内有购买原商品客户
        if (obj.filterCondition.indexOf("2") != -1) {
          params.isFilterPeriodBuyer = true;
        }
        if (obj.isAllItem != "0") {
          // 选择商品列表
          // console.log(this.itemList)
          // this.postForm.itemList = [...this.returnSelectGoodsAppoint, ...this.selectGoodsSkuList];
          if (obj.isAllItem == 1) this.postForm.itemList = [...this.returnSelectGoodsAppoint, ...this.selectGoodsSkuList];
          if (obj.isAllItem == 2) this.postForm.itemList = [...this.returnSelectGoodsExclude, ...this.selectGoodsSkuExclude];
          params.wareList = this.postForm.itemList.map((res) => {
            // return {
            //   price: res.jdPrice,
            //   wareId: res.wareId,
            //   wareLogo: res.logo,
            //   wareTitle: res.wareTitle,
            // };
            let obj = {
              price: res.jdPrice || res.price,
              wareId: res.wareId,
              wareLogo: res.logo || res.wareLogo,
              wareTitle: res.wareTitle,
              skuId: res.skuList && res.skuList.length ? res.skuList.map((val) => val.skuId).join(",") : res.skuId,
            };
            return obj;
          });
        } else {
          params.wareList = [];
          params.clearWare = true;
        }

        addOrdersCare(params)
          .then((res) => {
            this.disBtn1 = false;
            this.disBtn2 = false;
            this.loadBtn1 = false;
            this.loadBtn2 = false;
            res.code === 1 ? (this.$message.success(res.message), this.ModularBtn()) : this.$message.error(res.message);
          })
          .catch((e) => {
            this.disBtn2 = false;
            this.disBtn1 = false;
            this.loadBtn1 = false;
            this.loadBtn2 = false;
            // console.log(e);
          });
      }
    },

    moreBtn() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
        // path: "/backstage",
        // hash:'#/autograph',
      });
      window.open(routeUrl.href, "_blank");
    },
    shortBtnThree() {
      this.sendState = !this.sendState;
    },
    // shortBtnFour() {
    //   this.couponState = !this.couponState;
    // },
    shortBtnTwo() {
      this.smsState = !this.smsState;
    },
    // closeBaby() {
    //   this.babyState = false;
    // },
    // 选择模板的返回
    shortBtnTwo1(data) {
      if (typeof data != "boolean") {
        this.postForm.content = this.postForm.content + data.content;
      }
      this.smsState = !this.smsState;
    },
    // 短信记录的返回
    shortBtnTwo2(data) {
      this.smsState2 = !this.smsState2;
    },

    // 凑单商品选择
    goodsOderPopupBtn(event) {
      this.goodsOderState = false;
      // console.log(event);
      if (typeof event != "boolean") {
        // this.goodsStateLength = event.length;
        // console.log(event);
        this.remindConfigItemObj = event[0];
        this.postForm.remindConfigItem = event;
      }
    },

    // 插入短链接隐藏
    insertUrlChange(state, data) {
      if (data) this.postForm.content = this.postForm.content + " " + data.shortLink + " ";
      this.insertShortUrlShow = false;
    },
    // 关闭短链接
    handleCloseShort(val, obj) {
      this.insertShortUrlShow = false;
      if (val) {
        this.longUrllink = obj.originUrl2;
        this.insertContent(" " + obj.shortLink + " ", obj);
      }
    },
    insertContent(myValue, obj) {
      myValue = this.$ChineseVToEn(myValue, true);
      if (this.postForm.transformUrl) {
        this.postForm.content = this.postForm.content.replace(this.postForm.transformUrl, myValue);
      } else {
        this.postForm.content = this.postForm.content.replace(/#LandingPage#/g, myValue);
      }
      this.postForm.transformUrl = " " + obj.shortLink + " ";
    },

    /*
     * 关闭弹窗
     * */
    ModularBtn() {
      this.$parent.pageConditionCom = false;
      this.$emit("transferName", true);
    },
    ModularBtnClose() {
      this.$parent.pageConditionCom = false;
    },
    /*
     *  下一步
     * */
    nextBtn() {
      console.log("this.menuType:", this.menuType);
      let status = true;
      //任务名称不能为空
      if (!this.postForm.taskName) {
        this.$message.error("任务名称不能为空");
        return;
      }
      // if(this.postForm.limitSendNum&&this.postForm.sendNum<2){
      //   this.$message.error("限制发送数必须大于大于2");
      //   return;
      // }
      if (this.menuType == 1) {
        this.tableList.map((i) => {
          if (i.periodDay == 0 || !i.periodDay) {
            this.$message.error("商品回购周期不可为0！");
            status = false;
            return;
          }
        });
      }
      if (!status) {
        return;
      }
      //每天发送时段不能为空
      if (this.menuType == 2 || this.menuType == 3) {
        if (!this.postForm.endRemindTime || !this.postForm.startRemindTime) {
          this.$message.error("每天发送时段不能为空");
          return;
        }
      }
      if (this.postForm.startRemindTime && this.postForm.endRemindTime) {
        var startListRemind = this.postForm.startRemindTime.split(":");
        var endListRemind = this.postForm.endRemindTime.split(":");
        if (parseInt(startListRemind[0]) > parseInt(endListRemind[0])) {
          this.$message.warning("发送时段时间无效");
          return;
        } else if (parseInt(startListRemind[0]) == parseInt(endListRemind[0]) && parseInt(startListRemind[1]) > parseInt(endListRemind[1])) {
          this.$message.warning("发送时段时间无效");
          return;
        }
      }

      if (this.postForm.startLunchBreak && this.postForm.endLunchBreak) {
        var startList = this.postForm.startLunchBreak.split(":");
        var endList = this.postForm.endLunchBreak.split(":");
        if (parseInt(startList[0]) > parseInt(endList[0])) {
          this.$message.warning("发送时段时间无效");
          return;
        } else if (parseInt(startList[0]) == parseInt(endList[0]) && parseInt(startList[1]) > parseInt(endList[1])) {
          this.$message.warning("发送时段时间无效");
          return;
        }
      }

      if (this.menuType == 9 && !this.postForm.activitySendTimeType) {
        this.$message.error("发送时间不能为空");
        return;
      }
      console.log(this.postForm.isOrderMoney);
      if (this.postForm.isOrderMoney && this.postForm.startOrderMoney && this.postForm.endOrderMoney) {
        if (Number(this.postForm.startOrderMoney) > Number(this.postForm.endOrderMoney)) {
          this.$message.warning("实付金额初始数值不能大于结束数值");
          return;
        }
      }
      if (this.postForm.startProductNum && this.postForm.endProductNum && this.postForm.isProductNum) {
        if (Number(this.postForm.startProductNum) > Number(this.postForm.endProductNum)) {
          this.$message.warning("商品数量初始数值不能大于结束数值");
          return;
        }
      }
      if (this.postForm.dealCount && this.postForm.startBuyTotalCount && this.postForm.endBuyTotalCount) {
        if (parseInt(this.postForm.startBuyTotalCount) > parseInt(this.postForm.endBuyTotalCount)) {
          console.log(this.postForm.startBuyTotalCount);
          // console.log(this.postForm.endBuyTotalCount);
          console.log(this.postForm.startBuyTotalCount > this.postForm.endBuyTotalCount);
          this.$message.warning("交易次数初始数值不能大于结束数值");
          return;
        }
      }

      if (this.menuType == 9 && this.postForm.activityCodeNum == 0) {
        this.$message.error("活动码不能为空,请上传活动码后再进行后续操作");
        return;
      }
      //商品数量判断
      //  isProductNum: false, //发送条件 是否开启商品数量 1 开启(true) 0 关闭(false),
      //startProductNum: "", // 发送条件 商品数量开始,
      // endProductNum: "", // 发送条件 商品数量结束,
      if (this.postForm.isProductNum) {
        // if (
        //   this.postForm.startProductNum == "" ||
        //   this.postForm.endProductNum == ""
        // ) {
        //   this.$message.error("勾选中的商品数量范围不能为空");
        //   return;
        // }
        if (this.postForm.startProductNum != "" && this.postForm.endProductNum != "") {
          if (Number(this.postForm.startProductNum) > Number(this.postForm.endProductNum)) {
            this.$message.error("商品开始数量不能大于结束数量");
            return;
          }
        }
      }

      //过滤设置勾选判断
      if (this.postForm.filterCondition && this.postForm.filterCondition.length > 0) {
        try {
          if (this.postForm.filterCondition.includes("0") && this.postForm.filterWantTime == "") {
            this.$message.error("勾选中的同一个旺旺号提醒天数不能为空");
            return;
          }
          if (this.postForm.filterCondition.includes("1") && this.postForm.filterMobileTime == "") {
            this.$message.error("勾选中的同一个手机号提醒天数不能为空");
            return;
          }
        } catch (e) {}
      }

      //1、判断商品选择指定商品或者排除商品时，需判断具体商品不能为空
      let isAllItem = false,
        areaType = false;
      if (this.postForm.isAllItem === "1" || this.postForm.isAllItem === "2") {
        if (this.goodsStateLength !== 0) {
          isAllItem = false;
        } else {
          isAllItem = true;
        }
      } else {
        isAllItem = false;
      }

      //2、选择地区，选择自定义，需判断自定义地区不为空
      if (this.postForm.areaType == "3") {
        if (this.checkedList.length !== 0) {
          areaType = false;
        } else {
          areaType = true;
        }
      } else {
        areaType = false;
      }
      // console.log('自定义',this.checkedList.length);
      // console.log(areaType);
      if (isAllItem || areaType) {
        this.$message.error("请检查自定义地区和选择商品(指定商品或排除商品)是否不为空!");
        return;
        // this.isOne = true;
        this.isTwo = false;
        // 先隐藏
        // } else if (this.postForm.areaType == 3 && this.checkedList.length == 0) {
        //   this.$message.error("您选择了自定义地区，请检查自定义地区是否不为空!");
        //   // this.isOne = true;
        //   this.isTwo = false;
      } else if (isAllItem === true && areaType === false) {
        this.$message.error("您选择商品选择了指定商品或排除商品，请检查是否选择了具体的商品!");
        // this.isOne = true;
        this.isTwo = false;
      } else {
        // this.isOne = false;
        this.isTwo = true;
        // $(".myOne").slideToggle(500);
      }
      // 针对评分不能为空
      if (this.menuType == 14 || this.menuType == 15) {
        console.log(this.postForm.selectStart);
        if (this.postForm.selectStart.length <= 0) {
          this.$message.error("针对评分至少选择一项");
          return;
        }
      }
      // 嵌套抽屉显示
      // this.drawerWidth = '1600px';
      this.innerDrawer = true;
    },

    flagChange(value) {
      let checkedCount = value.length;
      // console.log(this.flagData);
      ///this.isIndeterminateTwo = checkedCount > 0 && checkedCount < this.flagData.length;
    },
    /*
     *  取消
     * */
    noneBtn() {
      this.areaState = false;
    },
    /*
     * 确认
     * */
    yesBtn() {
      this.areaState = false;
    },
    /*
     *  自定义显示
     *
     * */
    popupShowBtn() {
      this.postForm.areaType = "3";
      this.areaState = true;
    },
    /*
     *  禁止滚动事件
     * */
    bodyScroll(event) {
      event.preventDefault();
    },
    unique(arr, arr1) {
      let list = arr.filter((item) => item);
      let listArr = list.map((item) => Number(item));
      let list1 = arr1.filter((item) => item);
      let listArr1 = list1.map((item) => Number(item));
      console.log(listArr, listArr1);
      return [...new Set([...listArr, ...listArr1])];
    },
    changeisFilterFreeGoods(val){
      console.log("isFilterFreeGoods", val);
      this.postForm.isFilterFreeGoods = val;
      this.$forceUpdate();
    },
    handleSelectLevel(val){
      this.$forceUpdate();
      // if(val.includes('0')){
      //   this.postForm.memberSelectLevel = ["0"]
      // }else {
      //   this.postForm.memberSelectLevel = val.filter(item => item!==0);
      // }
    },
    changeMemberLevels(item){
      if (this.postForm.memberSelectLevel.length == 0) {
        this.postForm.memberSelectLevel = ["-1"];
      } else if (item == "-1") {
        this.postForm.memberSelectLevel = ["-1"];
      } else {
        this.postForm.memberSelectLevel.forEach((val, idx, arr) => {
          if (arr[idx] == "-1") {
            this.postForm.memberSelectLevel.splice(idx);
            this.postForm.memberSelectLevel.push(item);
          }
        });
      }
    },
  },
};
</script>
<style lang="scss">
.ask-content-x {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  .ask-icon {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
  }
  .ask-icon-select {
    position: absolute;
    bottom: 35px;
    display: none;
    // height: 80px;
    line-height: 20px;
    background-color: #fff;
    box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
    color: #999999;
    z-index: 9;
    width: 140px;
    text-align: center;
    left: 0;
    margin-left: 0;
    padding: 10px 10px;
  }
  .ask-icon-select:before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    right: 50%;
    margin-left: -4px;
    top: 100%;
    border-left: 8px solid transparent;
    border-top: 8px solid #fff;
    border-right: 8px solid transparent;
  }
}
.ask-content-x:hover {
  .ask-icon-select {
    // display: block;
  }
}
</style>
<style scoped lang="scss">
::v-deep .pickerTime .el-icon-date:before {
  content: "\E78E";
  padding: 0px 0 0px 71px !important;
}
::v-deep .pickerTime .el-icon-time:before {
  content: "\E71F";
  padding: 0px 0 0px 71px !important;
}
::v-deep .send-textare .el-textarea__inner {
  border: 1px solid #dcdfe6 !important;
  &:focus {
    border: 1px solid #fe4d45 !important;
  }
}
</style>
<style lang="scss">
.box-hugs {
  .el-picker-panel .time-select .el-poppe {
    overflow-y: auto;
  }
  .el-popper {
    overflow-y: auto;
  }
  .el-picker-panel__footer {
    display: none;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #666;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #666;
  }
}
</style>

<!--条件刷选-->
<style lang="scss" scoped>
/deep/ .time {
  .el-input__inner {
    padding: 0 8px 0 30px !important;
  }
}
* {
  font-family: "Microsoft YaHei";
}
.top_bg {
  box-sizing: border-box;
  padding: 12px;
  background: #fffaee;
  color: #333 !important;
  margin-left: 47px !important;
}
.sms-content-x {
  border-radius: 4px;
  padding: 5px 15px;
  width: 548px;
  height: 145px;
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  outline: 1px solid #c0c4cc;
}
.send-textare {
  color: red;
}
@mixin translateX($number) {
  -webkit-transform: translateX($number);
  -moz-transform: translateX($number);
  -ms-transform: translateX($number);
  -o-transform: translateX($number);
  transform: translateX($number);
}

@mixin translateY($number) {
  -webkit-transform: translateY($number);
  -moz-transform: translateY($number);
  -ms-transform: translateY($number);
  -o-transform: translateY($number);
  transform: translateY($number);
}

@mixin translate($number, $number2) {
  -webkit-transform: translateX($number) translateY($number2);
  -moz-transform: translateX($number) translateY($number2);
  -ms-transform: translateX($number) translateY($number2);
  -o-transform: translateX($number) translateY($number2);
  transform: translateX($number) translateY($number2);
}
.mask {
  //   position: fixed;
  //   bottom: 0;
  //   width: 100%;
  height: 100%;
  //   background: rgba(0, 0, 0, 0.5);
  //   // z-index: 99;
  //   z-index: 2000;
}
.explain {
  display: inline-block;
  width: 14px;
  height: 14px;
  padding: 3px;
  text-align: center;
  line-height: 6px;
  border-radius: 50%;
  color: #ccc;
  font-size: 12px;
  margin-left: 8px;
  border: 1px solid #ccc;
  cursor: default;
}
.box-hugs {
  // position: fixed;
  // bottom: 0;
  // left: 0;
  // width: 100%;
  height: 100%;
  // // background: rgba(0, 0, 0, 0.5);
  // z-index: 100;
  // overflow-y: auto;
  .box-content-hug {
    // position: relative;
    // width: 100%;
    // min-width: 1200px;
    height: 100%;
    // overflow-y: auto;
    .box-left {
      position: fixed;
      width: 19%;
      height: 100%;
      float: left;
      overflow: hidden;
      .btn-top {
        width: 36px;
        height: 36px;
        background: rgba(255, 255, 255, 0.5);
        float: right;
        cursor: pointer;
        img {
          display: block;
          margin: 10px auto;
          width: 16px;
        }
      }
    }

    .myOne {
      background: #fff;
    }
    .box-content {
      // width: 81%;
      height: 100%;

      background-color: #fff;
      // float: right;
      //overflow-y: auto;
      // padding: 35px 30px 35px 25px;
      // padding: 15px 0px 0px 0px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      overflow: auto;
      position: relative;
      overflow: hidden;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.2);
      }
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(0, 0, 0, 0.1);
      }
      .box-step {
        width: 100%;
        height: 50px;
        position: relative;
        margin-bottom: 25px;
        .box-background {
          width: 100%;
          height: 100%;
          opacity: 0.05;
        }
        .box-step-hug {
          position: absolute;
          left: 0;
          top: 0;
          height: 50px;
          width: 100%;
          overflow: hidden;
          .box-step-circle {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            float: left;
            margin-left: 20px;
            margin-top: 21px;
          }
          .box-step-title {
            margin-left: 20px;
            font-size: 16px;
            font-family: "Microsoft YaHei";
            font-weight: 600;
            line-height: 50px;
            color: rgba(51, 51, 51, 1);
            float: left;
          }
        }
      }
      .right-content {
        // overflow: hidden;
        margin-bottom: 10px;
        .right-content-left {
          float: left;
          width: 120px;
          font-size: 14px;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          line-height: 32px;
          color: rgba(51, 51, 51, 1);
          text-align: right;
        }
        .right-content-right {
          margin-left: 128px;
          width: auto;
          // overflow: hidden;
          .upload-demo {
            display: inline-block;
            margin-left: 20px;
          }
          .tips {
            padding-bottom: 1px;
            // border-bottom: 1px solid #308afa;
            // color: #308afa;
            cursor: pointer;
          }
          .exampleImg {
            display: none;
            width: 232px;
            height: 308px;
            background: url("../../../assets/images/tips.png") no-repeat;
            background-size: 232px 358px;
            background-position: 0% 0%;
            position: absolute;
            top: 0px;
            left: 0px;
            z-index: 99;
          }
          .activityNum {
            padding: 3px 20px;
            border-radius: 4px;
          }
          .difficulWrap {
            .title {
              padding-right: 8px;
            }
            .selBtn {
              display: inline-block;
              padding: 0px 6px;
              border: 1px solid #ccc;
              cursor: pointer;
              margin-right: 8px;
            }
            .selInput {
              width: 40px;
              margin: 0 8px;
            }
            .selType {
              width: 60px;
            }
            .tips {
              margin-left: 8px;
            }
          }
          span {
            font-size: 14px;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 32px;
            color: rgba(102, 102, 102, 1);
          }
          .ding {
            position: absolute;
            top: 0;
            right: 3px;
          }
          .el-input__inner {
            padding: 0 20px;
          }
          .bb {
            .el-radio:nth-last-of-type(1) {
              margin-right: 0;
            }
          }
          .sku_button {
            width: 188px;
            height: 32px;
            padding: 0 12px;
            border-radius: 3px;
            border: 1px solid #fe4d45;
            color: #fe4d45;
            background-color: #fff4f4;
            cursor: pointer;
            &:hover {
              color: #fe4d45;
              background-color: #ffe5e5;
            }
            &:active {
              color: #fe4d45;
              background-color: #ffe5e5;
            }
          }
          .yixuanzhe_button {
            width: 110px;
            height: 32px;
            padding: 0 12px;
            border-radius: 3px;
            border: 1px solid #fe4d45;
            color: #fe4d45;
            background-color: #fff4f4;
            opacity: 1;
            // border-radius: 2px;
            text-align: center;
            font-size: 14px;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 30px;
            float: right;
            cursor: pointer;
            &:hover {
              color: #fe4d45;
              background-color: #ffe5e5;
            }
          }
          .button {
            // width: 103px;
            // height: 30px;
            // background: rgba(255, 255, 255, 1);
            // border: 1px solid rgba(209, 210, 217, 1);
            padding: 0 10px;
            opacity: 1;
            // border-radius: 2px;
            text-align: center;
            font-size: 14px;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            line-height: 30px;
            color: rgba(102, 102, 102, 1);
            display: block;
            float: right;
            cursor: pointer;

            height: 32px;
            border-radius: 3px;
            background-color: #f7f8fe;
            border: 1px solid #7f85e9;
            color: #7f85e9;
            &:hover {
              background: rgba(174, 179, 241, 0.16);
              border: 1px solid #7f85e9 !important;
              color: #7f85e9 !important;
            }
            &:active {
              background: rgba(174, 179, 241, 0.24);
              border: 1px solid #7f85e9 !important;
              color: #7f85e9;
            }
          }
        }
        .table {
          max-height: 400px;
          overflow: auto;
          margin: 0 30px;
          .cycleInput {
            width: 60px;
            display: inline-block;
          }
          .edit_btn {
            color: #7f85e9;
            font-size: 14px;
            padding: 0px !important;
            border: 0px;
            height: 20px;
            line-height: 20px;
            width: auto;

            margin-right: 10px;
          }
          .del_btn {
            width: auto;
            font-size: 14px;
            padding: 0px !important;
            border: 0px;
            height: 20px;
            line-height: 20px;
            color: #fe4d45;
            margin-left: 0px;
            margin-right: 10px;
          }
        }
      }
      .next_box {
        height: 80px;
        background: rgba(255, 255, 255, 1);
        border-top: 1px solid #f0f0f0;
        margin-top: 360px;
        position: absolute;
        width: 100%;
        bottom: 0px;
      }
      .next {
        line-height: 32px;
        border-radius: 3px;
        float: right;
        margin: 24px 48px;
        opacity: 1;
        width: 98px;
        height: 32px;
        font-size: 14px;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        text-align: center;
        cursor: pointer;
        color: #ffffff;
        background-color: #fe4d45;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #fe4d45;
        }
      }
    }
  }
}
.selectBox {
  text-align: right;
  .headCnt {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .keepBtn {
    width: 98px;
    height: 32px;
    line-height: 30px;
    margin-top: 20px;
    text-align: center;
    background: rgba(254, 77, 69, 1);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
  }
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
  }
}
.two-content {
  .item-hug-left {
    float: left;
    overflow: hidden;
  }
  .item-hug-right {
    float: left;
  }
  .two-item {
    // overflow: hidden;
    margin-top: 10px;
    .item-left {
      float: left;
      width: 118px;
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      line-height: 32px;
      color: rgba(51, 51, 51, 1);
      text-align: right;
    }
    .item-right {
      margin-left: 118px;
      .tool {
        display: flex;
        align-items: center;
        height: 32px;
        p {
          box-sizing: border-box;
          padding: 0 8px;
          margin: 0 8px 0 0;
          font-size: 14px;
          border-radius: 3px;
          background-color: #f7f8fe;
          border: 1px solid #7f85e9;
          color: #7f85e9;
          &:hover {
            background: rgba(174, 179, 241, 0.16);
            border: 1px solid #7f85e9 !important;
            color: #7f85e9 !important;
          }
          &:active {
            background: rgba(174, 179, 241, 0.24);
            border: 1px solid #7f85e9 !important;
            color: #7f85e9;
          }
        }
      }
      .label_content {
        margin-bottom: 13px;
        display: flex;
        flex-wrap: wrap;
        .label_items {
          background: #fff;
          color: #7f85e9;
          margin-right: 4px;
          margin-bottom: 4px;
          font-size: 13px;
          padding: 4px 10px;
          border: 1px solid #e6e6e6;
          cursor: pointer;
          &:hover {
            border: 1px solid #fe4d45;
          }
        }
      }
    }
    .write-message-box {
      display: inline-block;
      vertical-align: top;
      .message-content-box {
        border: 1px solid rgba(230, 230, 230, 1);
        border-radius: 2px;
        font-size: 14px;
        width: 550px;

        .message-input-box {
          position: relative;
          font-size: 15px;
          .back-order-button {
            position: absolute;
            width: 68px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background-color: #f3f3f3;
            bottom: 1px;
            right: 1px;
          }
        }

        .tabs-foot {
          height: 53px;
          line-height: 53px;
          background-color: #f9fafb;
          padding: 0 8px;
          border-top: 1px solid #e6e6e6;
          .foot-left {
            float: left;
            font-size: 14px;
            span {
              display: inline-block;
              vertical-align: middle;
            }

            .ask-content {
              position: relative;
              display: inline-block;
              vertical-align: middle;
              cursor: pointer;
              .ask-icon {
                display: inline-block;
                vertical-align: middle;
                cursor: pointer;
                position: relative;
              }

              .ask-icon-select {
                position: absolute;
                bottom: 50px;
                margin-left: -158px;
                display: none;
                width: 375px;
                // height: 80px;
                line-height: 20px;
                padding: 20px;
                background-color: #fff;
                text-align: left;
                box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
                color: #999999;
              }
              .ask-icon-select:before {
                position: absolute;
                content: "";
                width: 0;
                height: 0;
                right: 50%;
                margin-left: -4px;
                top: 100%;
                border-left: 8px solid transparent;
                border-top: 8px solid #fff;
                border-right: 8px solid transparent;
              }
            }

            .ask-content:hover {
              .ask-icon-select {
                display: block;
              }
            }
          }
          .foot-right {
            float: right;
            height: 30px;
            margin-top: 11px;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            padding: 0 13px;
            /*background: rgba(46, 114, 248, 0.1);*/
            border: 1px solid #fff;
            border-radius: 2px;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            font-size: 14px;
            position: relative;
            .foot-right-bgc {
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 30px;
              opacity: 0.1;
            }
          }
        }
      }

      .message-tips-box {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        padding: 10px;
        background: rgba(255, 118, 0, 0.1);
        border-radius: 3px;
        margin-top: 4px;
        color: rgba(255, 118, 0, 1);
        font-size: 14px;
        line-height: 17px;
      }
    }
    .write-message-box2 {
      padding: 12px;
      background: #fafafa;
      width: 580px;
    }
  }

  .tool-button {
    font-size: 15px;
    display: inline-block;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    vertical-align: middle;
    padding: 8px 15px;
    /*background: rgba(46, 114, 248, 0.13);*/
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    /*color: #2E72F8;*/
    margin-right: 16px;
    cursor: pointer;
    position: relative;

    .tool-button-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 3px;
    }

    .tool-button-title {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .input-box {
    display: inline-block;
    vertical-align: middle;
    margin-right: 13px;
  }
  .test-button1 {
    position: relative;
    display: inline-block;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 6px;
    cursor: pointer;
    border-radius: 3px;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    vertical-align: bottom;
    margin-right: 8px;
    width: 98px;
    height: 32px;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .test_button2 {
    width: 98px;
    height: 32px;
    color: #999999;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }

  .xiao-hug {
    /*width: 40%;*/
    margin-left: 100px;
  }
  .mobile-box {
    position: relative;
    width: 256px;
    height: 504px;
    background: url("../../../assets/images/mobileScreen.png") no-repeat;
    .message-content {
      position: absolute;
      word-wrap: break-word;
      max-height: 250px;
      overflow-y: auto;
      padding: 12px 12px;
      border-radius: 6px;
      background-color: #fafafa;
      width: 210px;
      font-size: 14px;
      line-height: 20px;
      left: 50%;
      margin-left: -104.665px;
      text-align: left;
      top: 25.4%;
    }
  }

  .mobile-tips {
    margin-top: 12px;
    font-size: 16px;
    text-align: center;
    color: rgba(51, 51, 51, 1);
  }
}

/*.box-hug::-webkit-scrollbar {!*滚动条整体样式*!*/
/*width: 6px;     !*高宽分别对应横竖滚动条的尺寸*!*/
/*height: 1px;*/
/*}*/
/*.box-hug::-webkit-scrollbar-thumb {!*滚动条里面小方块*!*/
/*border-radius: 6px;*/
/*-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*/
/*background: #535353;*/
/*}*/
/*.box-hug::-webkit-scrollbar-track {!*滚动条里面轨道*!*/
/*-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*/
/*border-radius: 6px;*/
/*background: #EDEDED;*/
/*}*/
.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 10000;
  .popup-hug {
    width: 700px;
    height: 420px;
    background-color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    @include translate(-50%, -50%);
    .popup-text-top {
      height: 52px;
      overflow: hidden;
      background: rgba(244, 245, 249, 1);
      .span1 {
        font-size: 20px;

        font-family: "Microsoft YaHei";
        font-weight: 600;
        line-height: 52px;
        color: rgba(51, 51, 51, 1);
        display: block;
        float: left;
        margin-left: 30px;
        margin-right: 30px;
      }
      .span2 {
        font-size: 20px;
        line-height: 52px;
        display: block;
        float: right;
        margin-right: 20px;
        cursor: pointer;
      }
      span {
        font-size: 20px;
        font-family: "Microsoft YaHei";
        font-weight: 600;
        line-height: 52px;
        color: #333333;
      }
    }
    .area-hug {
      margin-top: 30px;
      padding-left: 20px;
      .area {
        margin-top: 10px;
        overflow: hidden;
      }
    }
    .button-hug {
      margin-top: 30px;
      border-top: 1px solid rgba(230, 230, 230, 1);
      padding-top: 12px;
      .button-small {
        width: 180px;
        margin: 0 auto;
      }
      /*width: 220px;*/
      /*margin: 30px auto;*/
    }
  }
}

@media screen and (max-width: 1550px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        margin-left: 70px;
      }
    }
  }
}
@media screen and (max-width: 1500px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        margin-left: 40px;
      }
    }
  }
}
@media screen and (max-width: 1450px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        margin-left: 20px;
      }
    }
  }
}
@media screen and (max-width: 1430px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        margin-left: 0px;
      }
    }
  }
}
@media screen and (max-width: 1410px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        margin-left: 0px;
      }
    }
  }
}
// @media screen and (max-width: 1450px) {
//   .box-hugs {
//     .two-content {
//       .xiao-hug {
//         margin-top: 30px;
//         margin-left: 20%;
//       }
//     }
//   }
// }

//
@media screen and (max-width: 1410px) {
}
@media screen and (max-width: 1395px) {
  .box-hugs {
    .two-content {
      .xiao-hug {
        // margin-top: 30px;
        // margin-left: 20%;
      }
    }
  }
  .box-hugs .box-content-hug .box-content {
    // min-height: 1290px;
  }
}

// //左侧出来动画函数
// .miniPage3 {
//   &-enter-active {
//     animation: bounceInRight 0.6s;
//   }
//   &-leave-active {
//     animation: bounceOutRight 0.6s;
//   }
// }
// @keyframes bounceInRight {
//   from {
//     opacity: 0;
//     transform: translateX(3000px);
//   }

//   60% {
//     opacity: 1;
//     // transform: translateX(-25px);
//   }

//   // 75% {
//   //   transform: translateX(10px);
//   // }

//   // 90% {
//   //   transform: translateX(-5px);
//   // }

//   to {
//     transform: translateX(0);
//   }
// }

// @keyframes bounceOutRight {
//   20% {
//     opacity: 1;
//     transform: translateX(-20px);
//   }

//   to {
//     opacity: 0;
//     transform: translateX(2000px);
//   }
// }

// .miniPage4 {
//   &-enter-active {
//     // animation: bounceInRight2 1s;
//   }
//   &-leave-active {
//     // animation: bounceOutRight2 0.8s;
//   }
// }
// @keyframes bounceInRight2 {
//   from {
//     opacity: 0;
//     transform: translateY(600px);
//   }
//   60% {
//     opacity: 1;
//     // transform: translateX(-25px);
//   }
//   to {
//     transform: translateY(-825px);
//   }
// }
// @keyframes bounceOutRight2 {
//   0% {
//     opacity: 1;
//     transform: translateY(-600px);
//   }
//   60% {
//     opacity: 1;
//     // transform: translateY(-100px);
//   }
//   to {
//     opacity: 0;
//     transform: translateY(0px);
//   }
// }
</style>
<style lang="scss">
// /deep/ .el-textarea__inner {
//     border: 1px solid #dcdfe6 !important;
//      &:focus{
//     border: 1px solid #fe4d45 !important;
//   }
// }
// .send-textare .el-textarea__inner {
// }

.fadeInTop {
  animation-name: fadeInTop 1s;
  -webkit-animation: fadeInTop 1s;
}
/*从右到左进入*/
@keyframes fadeInTop {
  from {
    opacity: 0.8;
    -webkit-transform: translateY(936px);
    transform: stranslateY(936px);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: stranslateY(0);
  }
}

@-webkit-keyframes fadeInTop {
  from {
    opacity: 0;
    -webkit-transform: translateY(936px);
    transform: translateY(936);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
.tool-button-bgc {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  height: 100%;
  opacity: 0.1;
}

.checkbox_filter_time .el-date-editor.el-input {
  width: 190px;
  margin: 10px 0 0;
}
.disBtn1 {
  cursor: not-allowed !important;
}
.disBtn2 {
  cursor: not-allowed !important;
}

.color_gray {
  span {
    font-size: 13px !important;
    color: #c0c4cc !important;
    margin-right: 1px;
  }
}

.more_text {
  display: inline-block;
  vertical-align: text-top;
  cursor: pointer;
}
.more_text:hover {
}
.tabs-button2 {
  display: inline-block;
  vertical-align: middle;
  padding: 0 13px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #e6e6e6;
  text-align: center;
  background-color: #fff;
  color: #2e72f8;
  margin-right: 9px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  cursor: pointer;
  margin-bottom: 8px;
}
</style>
<style lang="scss" scoped>
// .page_condition{
.page_title {
  height: 22px;
  font-size: 16px;
  /* font-family: PingFang SC; */
  font-weight: 500;
  line-height: 24px;
  color: rgba(51, 51, 51, 1);
  margin: 20px 0 20px 28px;
  display: inline-block;
}
.del_icon {
  width: 12px;
  height: 12px;
  color: rgba(204, 204, 204, 1);
  opacity: 1;
  display: inline-block;
  line-height: 12px;
  text-align: center;
  float: right;
  margin: 25px 30px;
  cursor: pointer;
  font-size: 16px;
  // background: pink;
  // box-sizing: content-box;
}
.del_icon:hover {
  color: #fe4d45;
}
.circle_icon {
  width: 22px;
  height: 22px;
  background: rgba(254, 77, 69, 1);
  border-radius: 50%;
  opacity: 1;
  display: inline-block;
  text-align: center;
  line-height: 22px;
  color: #fff;
  font-size: 14px;
  margin-right: 8px;
}
.top_step {
  height: 46px;
  line-height: 46px;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  box-sizing: content-box;
  position: relative;
  // margin-bottom: 40px;
}
.top_step_item {
  font-size: 14px;
  /* font-family: PingFang SC; */
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  width: 50%;
  display: inline-block;
  text-align: center;
  border-bottom: 2px solid #fe4d45;
}
.step3 {
  color: #666;
  border-bottom: 0px;
  .circle_icon {
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(254, 77, 69, 1);
    color: #fe4d45;
    line-height: 20px;
  }
}
.step2 {
  color: #999;
  border-bottom: 0px;
  .circle_icon {
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    color: #cccccc;
    line-height: 20px;
  }
}
.step4 {
  border-bottom: 2px solid #fe4d45;
}
.to_next {
  display: inline-block;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: -8px;
  width: 10px;
  color: #b9b9b9;
  font-size: 18px;
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #ccc !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
}
.topTis {
  display: flex;
  align-items: baseline;
  // margin: 0 0 38px 66px;
  color: #999;
  font-size: 13px;
  margin: 18px 0px 16px 96px;
  .desc {
    padding-left: 20px;
    line-height: 20px;
  }
  .i_icon {
    width: 14px;
    height: 14px;
    background: rgba(254, 143, 138, 1);
    opacity: 1;
    display: inline-block;
    line-height: 14px;
    text-align: center;
    border-radius: 7px;
    color: #fff;
    font-size: 12px;
    margin-right: 8px;
  }
  p {
    margin: 0px;
    // height: 18px;
    line-height: 18px;
    width: 580px;
  }
}
.topTis2 {
  margin: 18px 0px 16px 90px;
  p {
    width: 580px;
  }
}
.footInfo {
  display: flex;
  justify-content: space-between;
  margin-top: 9px;
  font-size: 14px;
  color: #333;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 28px;
    outline: none;
    border: none;
    background-color: white;
    border-radius: 2px;
    font-size: 13px;
  }
  div {
    display: flex;
    align-items: center;
  }
  .select {
    color: #7f85e9;
    background: rgba(127, 133, 233, 0.1);
    border: 1px solid rgba(127, 133, 233, 1);
  }
  .keep_button1 {
    // margin: 0 10px 0 8px;
    width: 76px;
    height: 28px;
    opacity: 1;
    border-radius: 3px;
    font-size: 13px;
    margin-right: 8px;
    cursor: pointer;
    border: 1px solid #fe4d45;
    color: #fe4d45;
    background-color: #fff4f4;
    &:hover {
      color: #fe4d45;
      background-color: #ffe5e5;
    }
  }
  .keep_button2 {
    // margin: 0 10px 0 8px;
    width: 76px;
    height: 28px;
    border-radius: 3px;
    font-size: 13px;
    /* font-family: PingFang SC; */
    font-weight: 400;
    margin-right: 8px;
    cursor: pointer;
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
}
.ask-content {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  .ask-icon {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
  }
  .ask-icon-select {
    position: absolute;
    bottom: 35px;
    margin-left: -130px;
    display: none;
    width: 375px;
    // height: 80px;
    line-height: 20px;
    padding: 20px;
    background-color: #fff;
    text-align: left;
    box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
    color: #999999;
    z-index: 9;
  }
  .ask-icon-select:before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    right: 50%;
    margin-left: -4px;
    top: 100%;
    border-left: 8px solid transparent;
    border-top: 8px solid #fff;
    border-right: 8px solid transparent;
  }
}
.ask-content:hover {
  .ask-icon-select {
    display: block;
  }
}
.btnList {
  display: flex;
  align-items: center;
  flex-flow: wrap;
  // height: 32px;
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    border-radius: 2px;
    cursor: pointer;
  }
  .btnBox {
    position: relative;
    overflow: hidden;
    height: 31px;
    margin-bottom: 6px;
    margin-right: 16px;
    border-radius: 3px;
    .btn {
      width: 114px;
      height: 31px;
      color: #999999;
      border: 1px solid #cccccc;
      padding-left: 15px;
      border-radius: 3px;
      padding-right: 15px;
      cursor: pointer;
      &:hover {
        border: 1px solid #fe4d45;
        //  color: #fe4d45;
      }
    }
    .btn_active {
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .check {
      position: absolute;
      right: -16px;
      bottom: -16px;
      width: 30px;
      height: 30px;
      background-color: #fe4d45;
      border-radius: 50%;
    }
    i {
      position: absolute;
      right: 16px;
      bottom: 15px;
      font-size: 10px;
      color: #fff;
    }
  }
}

.button3 {
  width: 115px;
  padding-left: 18px;
  height: 32px;
  opacity: 1;
  border-radius: 4px;
  margin-left: 48px;
  line-height: 30px;
  color: #999999;
  border: 1px solid #cccccc;
  background-color: #fff;
  &:hover {
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff4f4;
  }
}
.el-textarea__inner {
  border: 0 !important;
  &:focus {
    border: 1px solid #fe4d45 !important;
  }
}

.btn_all {
  margin-top: 30px;
  height: 80px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
  position: absolute;
  bottom: 0px;
  width: 100%;

  .button1 {
    width: 98px;
    height: 32px;
    opacity: 1;
    border-radius: 3px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 30px;
    margin-right: 8px;
    text-align: center;
    cursor: pointer;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .button2 {
    width: 98px;
    height: 32px;
    opacity: 1;
    border-radius: 3px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 32px;
    text-align: center;
    margin-right: 48px;
    cursor: pointer;
    color: #ffffff;
    border: 1px solid #fe4d45;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
}

// }
</style>
<style lang="scss">
@media only screen and (max-width: 1900px) {
  .outside_Drawer {
    width: 850px !important;
  }
  .inner_Drawer {
    width: 1000px !important;
  }
  .xiao_hug {
    left: 620px !important;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss">
.el-drawer.rtl {
  overflow: scroll;
}
</style>
